(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("4wpee", function(module, exports) {

$parcel$export(module.exports, "useTarget", function () { return $34adb86f3e3b9f27$export$7df435cf7131d47a; });
$parcel$export(module.exports, "CustomScripts", function () { return $34adb86f3e3b9f27$export$a95e8d0bb21c576d; });
$parcel$export(module.exports, "Content", function () { return $34adb86f3e3b9f27$export$7c6e2c02157bb7d2; });
$parcel$export(module.exports, "MenuEntrypoint", function () { return $34adb86f3e3b9f27$export$fc2e8d9b7c3d7836; });
$parcel$export(module.exports, "render", function () { return $34adb86f3e3b9f27$export$b3890eb0ae9dca99; });
$parcel$export(module.exports, "goTo", function () { return $34adb86f3e3b9f27$export$95e8d77caafa3e06; });
$parcel$export(module.exports, "initSmartnav", function () { return $34adb86f3e3b9f27$export$8d4a4a389ba6cafa; });
$parcel$export(module.exports, "init", function () { return $34adb86f3e3b9f27$export$2cd8252107eb640b; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $5YOUh = parcelRequire("5YOUh");

var $j4B9x = parcelRequire("j4B9x");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $hfCPd = parcelRequire("hfCPd");

var $1xf0g = parcelRequire("1xf0g");

var $5iUQc = parcelRequire("5iUQc");

var $kJhYp = parcelRequire("kJhYp");

var $hXgYL = parcelRequire("hXgYL");

var $9rqV0 = parcelRequire("9rqV0");

var $IFWJb = parcelRequire("IFWJb");

var $jWAMh = parcelRequire("jWAMh");

var $7GW0c = parcelRequire("7GW0c");

var $b5aRK = parcelRequire("b5aRK");

var $i6QHm = parcelRequire("i6QHm");

var $ePRCc = parcelRequire("ePRCc");

var $4j4tH = parcelRequire("4j4tH");

var $dJhID = parcelRequire("dJhID");

var $bbixw = parcelRequire("bbixw");

var $5bEXW = parcelRequire("5bEXW");

var $8L1B1 = parcelRequire("8L1B1");

var $iaHPQ = parcelRequire("iaHPQ");

var $jjS2R = parcelRequire("jjS2R");

var $efwy1 = parcelRequire("efwy1");

var $a8uU7 = parcelRequire("a8uU7");

var $1apRQ = parcelRequire("1apRQ");

var $hBcYV = parcelRequire("hBcYV");

var $4QdUt = parcelRequire("4QdUt");

var $aSJcu = parcelRequire("aSJcu");

var $78zWm = parcelRequire("78zWm");

var $3QcL7 = parcelRequire("3QcL7");

var $cdK26 = parcelRequire("cdK26");

var $2ZaET = parcelRequire("2ZaET");

var $lKNu0 = parcelRequire("lKNu0");

var $hv3Nv = parcelRequire("hv3Nv");

var $lihS4 = parcelRequire("lihS4");

var $6e14p = parcelRequire("6e14p");

var $8E2YL = parcelRequire("8E2YL");

var $e4Coc = parcelRequire("e4Coc");

var $6EwcS = parcelRequire("6EwcS");

var $gUsPc = parcelRequire("gUsPc");

var $5BWWq = parcelRequire("5BWWq");

var $8yLAG = parcelRequire("8yLAG");

var $hm3Un = parcelRequire("hm3Un");
function $34adb86f3e3b9f27$export$7df435cf7131d47a(attributes, embedElement, mode, isIndexAllowed, param) {
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var match$1 = $hBcYV.useRouter(undefined);
    var goTo = match$1.goTo;
    var navMenuConfig = $lKNu0.useSettings(attributes);
    var getTargetSelector = function getTargetSelector(mode) {
        if (mode) return $2whNH.flatMap(navMenuConfig, function(config) {
            return config.hamburgerTarget;
        });
        else return $2whNH.flatMap(navMenuConfig, function(config) {
            return config.topbarTarget;
        });
    };
    var getTriggerButtonSelector = function getTriggerButtonSelector(mode) {
        return $2whNH.flatMap(attributes, function(attr) {
            if (mode) return $2whNH.flatMap(navMenuConfig, function(config) {
                return config.hamburgerTriggerButtonTarget;
            });
        });
    };
    var getTargetStyle = function getTargetStyle(mode) {
        return $2whNH.flatMap(attributes, function(attr) {
            if (mode) return $2whNH.flatMap(navMenuConfig, function(config) {
                return config.hamburgerTargetStyle;
            });
            else return $2whNH.flatMap(navMenuConfig, function(config) {
                return config.topbarTargetStyle;
            });
        });
    };
    var getTargetElement = function getTargetElement(param) {
        var partial_arg = document;
        return $2whNH.map($2whNH.flatMap(getTargetSelector(mode), function(param) {
            return $loT9g.nullable_to_opt(partial_arg.querySelector(param));
        }), function(__x) {
            return $7GW0c.$$Element.setAttribute(__x, "style", getTargetStyle(mode));
        });
    };
    var match$2 = $g85JO.useState(function() {
        return getTargetElement(undefined);
    });
    var setTargetElement = match$2[1];
    var targetElement = match$2[0];
    var canContinueWithoutInjection = $2whNH.mapWithDefault(embedElement, false, function(el) {
        return $2whNH.mapWithDefault(targetElement, false, function(el2) {
            return el2.contains(el);
        });
    });
    var documentReadyState = $8yLAG.useDocumentReadyStateChange(undefined);
    var shouldReport = documentReadyState === /* Complete */ 2;
    var refreshTargetElement = function refreshTargetElement(forceUpdate, param) {
        var el = getTargetElement(undefined);
        if (el === undefined) return;
        var el$1 = $loT9g.valFromOption(el);
        $iv6Yc._1(setTargetElement, function(previousEl) {
            if (previousEl === undefined || forceUpdate) return $loT9g.some(el$1);
            else return previousEl;
        });
    };
    $g85JO.useEffect(function() {
        refreshTargetElement(true, undefined);
    }, [
        mode
    ]);
    $g85JO.useEffect(function() {
        refreshTargetElement(false, undefined);
    }, [
        documentReadyState
    ]);
    var observedSelector = mode ? $2whNH.flatMap(navMenuConfig, function(config) {
        return config.hamburgerContainerTarget;
    }) : $2whNH.flatMap(navMenuConfig, function(config) {
        return config.topbarContainerTarget;
    });
    var observedTarget = $hv3Nv.use(undefined, observedSelector);
    $78zWm.use({
        attributes: true,
        characterData: false,
        childList: false,
        subtree: false
    }, observedTarget, function(param) {
        return refreshTargetElement(true, param);
    });
    var openNavMenu = function openNavMenu(param) {
        $2whNH.forEach($i7mYY.get($i7mYY.keep($i7mYY.keep(config.categories, function(category) {
            return category.visibleInMenuBar;
        }), function(category) {
            if ($1xf0g.hasAnyItems(category)) return true;
            else if ($1xf0g.isIndexNode(category)) return isIndexAllowed;
            else return false;
        }), 0), function(category) {
            $iv6Yc._3(goTo, undefined, undefined, {
                TAG: /* ListPage */ 1,
                _0: {
                    listPageType: {
                        TAG: /* Category */ 0,
                        _0: category.id
                    },
                    viewPLP: false,
                    filters: undefined,
                    sort: undefined
                }
            });
        });
    };
    $g85JO.useEffect(function() {
        if ($e4Coc.getMenuOpened(undefined)) openNavMenu(undefined);
    }, []);
    var handleTriggerButtonClick = function handleTriggerButtonClick(e) {
        e.stopImmediatePropagation();
        openNavMenu(undefined);
    };
    $g85JO.useEffect(function() {
        var selector = getTriggerButtonSelector(mode);
        if (selector === undefined) return;
        var elements = $i7mYY.keepMap(Array.prototype.slice.call(document.querySelectorAll(selector)), $b5aRK.ofNode);
        $i7mYY.forEach(elements, function(element) {
            $iaHPQ.wipeDOMEvents(element).addEventListener("click", handleTriggerButtonClick);
        });
        return function(param) {
            $i7mYY.forEach(elements, function(element) {
                element.removeEventListener("click", handleTriggerButtonClick);
            });
        };
    }, [
        mode
    ]);
    return {
        targetSelector: getTargetSelector(mode),
        targetElement: targetElement,
        canContinueWithoutInjection: canContinueWithoutInjection,
        shouldReport: shouldReport
    };
}
function $34adb86f3e3b9f27$var$NavMenuEntrypoint$CustomScripts(Props) {
    var attributes = Props.attributes;
    var navMenuConfig = $lKNu0.useSettings(attributes);
    var injectCSS = $2whNH.flatMap(navMenuConfig, function(config) {
        return config.injectCSS;
    });
    var injectJS = $2whNH.flatMap(navMenuConfig, function(config) {
        return config.injectJS;
    });
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($2ZaET.OptionMap.make, {
        option: injectCSS,
        children: function children(css) {
            return /*#__PURE__*/ $g85JO.createElement($hXgYL.make, {
                css: css
            });
        }
    }), /*#__PURE__*/ $g85JO.createElement($2ZaET.OptionMap.make, {
        option: injectJS,
        children: function children(js) {
            return /*#__PURE__*/ $g85JO.createElement($5iUQc.make, {
                js: js
            });
        }
    }));
}
$34adb86f3e3b9f27$var$NavMenuEntrypoint$CustomScripts.displayName = "NavMenuEntrypoint.CustomScripts";
var $34adb86f3e3b9f27$export$a95e8d0bb21c576d = {
    make: $34adb86f3e3b9f27$var$NavMenuEntrypoint$CustomScripts
};
function $34adb86f3e3b9f27$var$NavMenuEntrypoint$Content(Props) {
    var embedType = Props.embedType;
    var onOpenLink = Props.onOpenLink;
    var attributes = Props.attributes;
    var element = Props.element;
    var match = $8E2YL.use(undefined);
    var setBreakpointOverride = match.setBreakpointOverride;
    var config = match.config;
    var match$1 = $aSJcu.use(undefined);
    var windowWidth = match$1.windowSize.width;
    var match$2 = $hBcYV.useRouter(undefined);
    var setIsHistoryEnabled = match$2.setIsHistoryEnabled;
    var previewMode = match$2.previewMode;
    var isStyleLoaded = $6e14p.useIsStyleLoaded(undefined);
    var navMenuConfig = $lKNu0.useSettings(attributes);
    var mode = $2whNH.map($2whNH.flatMap(navMenuConfig, function(config) {
        return config.breakpointMaxWidth;
    }), function(maxWidth) {
        if (maxWidth > windowWidth) return /* Hamburger */ 1;
        else return /* Topbar */ 0;
    });
    var isTopbarEnabled = $2whNH.getWithDefault($2whNH.map(navMenuConfig, function(config) {
        return config.topbarEnabled;
    }), true);
    var mode$1 = isTopbarEnabled ? $2whNH.getWithDefault(mode, /* Topbar */ 0) : /* Hamburger */ 1;
    var breakpointOverride = $2whNH.mapWithDefault(navMenuConfig, true, function(settings) {
        return settings.topbarEnabled;
    }) ? undefined : /* Sm */ 1;
    $g85JO.useEffect(function() {
        $iv6Yc._1(setBreakpointOverride, function(param) {
            return breakpointOverride;
        });
        $iv6Yc._1(setIsHistoryEnabled, function(clearIntent, previewMode, route) {
            if (mode$1) return true;
            if (clearIntent) return true;
            if (typeof route !== "number") switch(route.TAG | 0){
                case /* PDP */ 2:
                case /* QuickView */ 3:
                    return true;
                default:
            }
            if (previewMode !== undefined) {
                if (typeof previewMode === "number") return previewMode === 0;
                else return true;
            } else return false;
        });
    }, [
        mode$1
    ]);
    var isIndexAllowed = mode$1 ? $2whNH.mapWithDefault(navMenuConfig, false, function(config) {
        return config.hamburgerHomeEnabled;
    }) : $2whNH.mapWithDefault(navMenuConfig, false, function(config) {
        return config.topbarHomeEnabled;
    });
    var match$3 = $34adb86f3e3b9f27$export$7df435cf7131d47a(attributes, element, mode$1, isIndexAllowed, undefined);
    var shouldReport = match$3.shouldReport;
    var targetElement = match$3.targetElement;
    var targetSelector = match$3.targetSelector;
    var zIndex = mode$1 ? $2whNH.getWithDefault($2whNH.flatMap(navMenuConfig, function(config) {
        return config.hamburgerZIndex;
    }), $a8uU7.emptyCtx.zIndex) : $2whNH.getWithDefault($2whNH.flatMap(navMenuConfig, function(config) {
        return config.topbarZIndex;
    }), $a8uU7.emptyCtx.zIndex);
    var threeColumnLayout = mode$1 ? false : $2whNH.getWithDefault($2whNH.flatMap(navMenuConfig, function(config) {
        return config.topbarThreeColumnLayout;
    }), $a8uU7.emptyCtx.threeColumnLayout);
    var isModalOpen;
    var tmp = match$2.route;
    isModalOpen = typeof tmp === "number" || tmp.TAG === /* Home */ 0 ? false : true;
    var tmp$1 = {
        embedType: embedType
    };
    if (onOpenLink !== undefined) tmp$1.onOpenLink = $loT9g.valFromOption(onOpenLink);
    if (attributes !== undefined) tmp$1.attributes = $loT9g.valFromOption(attributes);
    var tmp$2 = {
        className: $ezf3v.prefix("h-full"),
        children: /*#__PURE__*/ $g85JO.createElement($3QcL7.Provider.make, {
            value: {
                mode: mode$1,
                currentFullPath: $a8uU7.emptyCtx.currentFullPath,
                currentL1: $a8uU7.emptyCtx.currentL1,
                currentL2: $a8uU7.emptyCtx.currentL2,
                currentL3: $a8uU7.emptyCtx.currentL3,
                pageFlipTransitionSpeedMs: $a8uU7.emptyCtx.pageFlipTransitionSpeedMs,
                modalTransitionSpeedMs: $a8uU7.emptyCtx.modalTransitionSpeedMs,
                modalBackdropHeight: $a8uU7.emptyCtx.modalBackdropHeight,
                modalBackdropOpacity: $a8uU7.emptyCtx.modalBackdropOpacity,
                modalMaxWidth: $a8uU7.emptyCtx.modalMaxWidth,
                zIndex: zIndex,
                maxLevels: $a8uU7.emptyCtx.maxLevels,
                positions: $a8uU7.emptyCtx.positions,
                threeColumnLayout: threeColumnLayout,
                isModalOpen: isModalOpen,
                isIndexAllowed: isIndexAllowed
            },
            children: /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                condition: isStyleLoaded,
                children: /*#__PURE__*/ $g85JO.createElement($8L1B1.make, {
                    config: config,
                    children: /*#__PURE__*/ $g85JO.createElement($IFWJb.Provider.make, {
                        children: /*#__PURE__*/ $g85JO.createElement($jWAMh.make, tmp$1)
                    })
                })
            })
        })
    };
    if (attributes !== undefined) tmp$2.attributes = $loT9g.valFromOption(attributes);
    var content = /*#__PURE__*/ $g85JO.createElement($ePRCc.make, {
        initiator: "nav-menu",
        style: {
            height: "100%",
            width: "100%"
        },
        className: $ezf3v.prefix("text-inherit"),
        portal: false,
        children: null
    }, /*#__PURE__*/ $g85JO.createElement($i6QHm.make, {
        embedType: embedType
    }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
        condition: $7bjme.notequal(previewMode, /* PreviewLive */ 1) && previewMode !== undefined,
        children: /*#__PURE__*/ $g85JO.createElement($4j4tH.make, {})
    }), /*#__PURE__*/ $g85JO.createElement($6EwcS.make, {
        configId: config.id,
        accountId: config.accountId,
        historyEnabled: config.settings.historyEnabled,
        favoritesEnabled: config.settings.favoritesEnabled,
        children: /*#__PURE__*/ $g85JO.createElement($lihS4.make, {
            children: /*#__PURE__*/ $g85JO.createElement($gUsPc.make, tmp$2)
        })
    }));
    if (match$3.canContinueWithoutInjection) return content;
    var node;
    if (targetSelector !== undefined) {
        if (targetElement === undefined) return /*#__PURE__*/ $g85JO.createElement($ePRCc.make, {
            initiator: "nav-menu",
            portal: false,
            children: /*#__PURE__*/ $g85JO.createElement($bbixw.make, {
                error: $4QdUt.makeError(shouldReport, "Nav Menu: Failed to find a target element with query selector `" + targetSelector + "` for " + (mode$1 ? "hamburger" : "topbar") + "."),
                extraInfo: {
                    querySelector: targetSelector
                }
            })
        });
        node = $loT9g.valFromOption(targetElement);
    } else {
        if (targetElement === undefined) return /*#__PURE__*/ $g85JO.createElement($ePRCc.make, {
            initiator: "nav-menu",
            portal: false,
            children: /*#__PURE__*/ $g85JO.createElement($bbixw.make, {
                error: $4QdUt.makeError(shouldReport, "Nav Menu: No target element is configured for " + (mode$1 ? "hamburger" : "topbar") + ".")
            })
        });
        node = $loT9g.valFromOption(targetElement);
    }
    return /*#__PURE__*/ $g85JO.createElement($1apRQ.make, {
        node: node,
        children: content
    });
}
$34adb86f3e3b9f27$var$NavMenuEntrypoint$Content.displayName = "NavMenuEntrypoint.Content";
var $34adb86f3e3b9f27$var$make = /*#__PURE__*/ $g85JO.memo($34adb86f3e3b9f27$var$NavMenuEntrypoint$Content);
var $34adb86f3e3b9f27$export$7c6e2c02157bb7d2 = {
    make: $34adb86f3e3b9f27$var$make
};
function $34adb86f3e3b9f27$var$NavMenuEntrypoint$MenuEntrypoint(Props) {
    var configId = Props.configId;
    var embedTypeOpt = Props.embedType;
    var attributes = Props.attributes;
    var element = Props.element;
    var trackers = Props.trackers;
    var onAddToCart = Props.onAddToCart;
    var onOpenLink = Props.onOpenLink;
    var embedType = embedTypeOpt !== undefined ? embedTypeOpt : /* Bottombar */ 0;
    var attributes$1 = $9rqV0.Attributes.useAttributesObserver(element, attributes);
    var namespace = $9rqV0.getNamespace(attributes$1);
    var accountId = $2whNH.flatMap(attributes$1, function(attr) {
        return attr.account;
    });
    var navMenuConfig = $e4Coc.getSettings(undefined, undefined);
    var breakpointOverride = $2whNH.mapWithDefault(navMenuConfig, true, function(settings) {
        return settings.topbarEnabled;
    }) ? undefined : /* Sm */ 1;
    $g85JO.useEffect(function() {
        if (!$cdK26.isProductPage(undefined)) $hm3Un.clearLastCategory(undefined);
    }, []);
    var tmp = {};
    if (attributes$1 !== undefined) tmp.attributes = $loT9g.valFromOption(attributes$1);
    var tmp$1 = {
        embedType: embedType,
        configId: configId
    };
    if (onOpenLink !== undefined) tmp$1.onOpenLink = $loT9g.valFromOption(onOpenLink);
    if (attributes$1 !== undefined) tmp$1.attributes = $loT9g.valFromOption(attributes$1);
    if (element !== undefined) tmp$1.element = $loT9g.valFromOption(element);
    var tmp$2 = {
        configId: configId,
        children: /*#__PURE__*/ $g85JO.createElement($hfCPd.Provider.make, {
            children: null
        }, /*#__PURE__*/ $g85JO.createElement($34adb86f3e3b9f27$var$NavMenuEntrypoint$CustomScripts, tmp), /*#__PURE__*/ $g85JO.createElement($34adb86f3e3b9f27$var$make, tmp$1)),
        enableTrimmingTreeByReferrer: false
    };
    if (breakpointOverride !== undefined) tmp$2.breakpointOverride = $loT9g.valFromOption(breakpointOverride);
    var tmp$3 = {
        children: /*#__PURE__*/ $g85JO.createElement($6e14p.make, $6e14p.makeProps(/*#__PURE__*/ $g85JO.createElement($5BWWq.make, {
            value: {
                accountId: accountId,
                trackers: trackers,
                onAddToCart: onAddToCart,
                onOpenLink: onOpenLink
            },
            children: /*#__PURE__*/ $g85JO.createElement($aSJcu.Provider.make, {
                children: /*#__PURE__*/ $g85JO.createElement($hBcYV.make, {
                    configId: configId,
                    embedType: embedType,
                    children: /*#__PURE__*/ $g85JO.createElement($8E2YL.make, tmp$2)
                })
            })
        }), undefined, undefined))
    };
    if (namespace !== undefined) tmp$3.namespace = $loT9g.valFromOption(namespace);
    return /*#__PURE__*/ $g85JO.createElement($g85JO.StrictMode, {
        children: /*#__PURE__*/ $g85JO.createElement($efwy1.Provider.make, tmp$3)
    });
}
$34adb86f3e3b9f27$var$NavMenuEntrypoint$MenuEntrypoint.displayName = "NavMenuEntrypoint.MenuEntrypoint";
var $34adb86f3e3b9f27$export$fc2e8d9b7c3d7836 = {
    make: $34adb86f3e3b9f27$var$NavMenuEntrypoint$MenuEntrypoint
};
function $34adb86f3e3b9f27$export$b3890eb0ae9dca99(configId, onOpenLink, onAddToCart, trackers, isLauncher, element, attributes) {
    var elementId = element.id;
    var newDictEntry = [
        [
            elementId,
            element
        ]
    ];
    var attributes$1 = $2whNH.map(attributes, function(attr) {
        return attr.attributes;
    });
    var elements = window.smartNavElementsMenu;
    var prim1 = $2whNH.mapWithDefault(elements, $d3YYW.fromArray(newDictEntry), function(elements) {
        return $d3YYW.fromArray($i7mYY.concat($d3YYW.entries(elements), newDictEntry));
    });
    var prim0 = window;
    prim0.smartNavElementsMenu = prim1;
    var tmp = {
        configId: configId,
        embedType: /* Menu */ 4,
        element: element,
        key: configId
    };
    if (attributes$1 !== undefined) tmp.attributes = $loT9g.valFromOption(attributes$1);
    if (trackers !== undefined) tmp.trackers = $loT9g.valFromOption(trackers);
    if (onAddToCart !== undefined) tmp.onAddToCart = $loT9g.valFromOption(onAddToCart);
    if (onOpenLink !== undefined) tmp.onOpenLink = $loT9g.valFromOption(onOpenLink);
    $5bEXW.render(/*#__PURE__*/ $g85JO.createElement($dJhID.make, {
        componentName: "Root",
        children: /*#__PURE__*/ $g85JO.createElement($34adb86f3e3b9f27$var$NavMenuEntrypoint$MenuEntrypoint, tmp)
    }), element);
}
function $34adb86f3e3b9f27$export$95e8d77caafa3e06(quickView, quickNav, replaceState, preserveScroll, namespace) {
    $kJhYp.goTo(namespace, undefined, quickView, quickNav, replaceState, preserveScroll, undefined);
}
function $34adb86f3e3b9f27$export$8d4a4a389ba6cafa(index, element) {
    return $34adb86f3e3b9f27$var$_initSmartnav.apply(this, arguments);
}
function $34adb86f3e3b9f27$var$_initSmartnav() {
    $34adb86f3e3b9f27$var$_initSmartnav = (0, $5YOUh._)(function(index, element) {
        var attributes, configId;
        return (0, $j4B9x.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    $9rqV0.Attributes.autoAssignNamespaces(undefined);
                    attributes = $9rqV0.Attributes.fromElement(element);
                    return [
                        4,
                        $jjS2R.getConfigId(undefined, undefined, false, attributes, /* Menu */ 4)
                    ];
                case 1:
                    configId = _state.sent();
                    if (configId !== undefined) return [
                        2,
                        $34adb86f3e3b9f27$export$b3890eb0ae9dca99(configId, undefined, undefined, undefined, false, element, {
                            embedType: /* Menu */ 4,
                            attributes: attributes
                        })
                    ];
                    return [
                        2
                    ];
            }
        });
    });
    return $34adb86f3e3b9f27$var$_initSmartnav.apply(this, arguments);
}
function $34adb86f3e3b9f27$export$2cd8252107eb640b(param) {
    var element = document.querySelector("#maker-smartnav-menu");
    if (element == null) console.error("Could not initialize SmartNav: no element found");
    else $34adb86f3e3b9f27$export$8d4a4a389ba6cafa(0, element);
}
 /* make Not a pure module */ 
});
parcelRegister("5iUQc", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $3dcab9980fca6188$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $gZfyt = parcelRequire("gZfyt");
function $3dcab9980fca6188$var$InjectJS(Props) {
    var js = Props.js;
    return /*#__PURE__*/ $g85JO.createElement($gZfyt.make, {
        children: "<script>\n		try {\n			" + js + '\n		} catch (e) {\n			console.error("Error executing JS:", e)\n		}\n	</script>'
    });
}
$3dcab9980fca6188$var$InjectJS.displayName = "InjectJS";
var $3dcab9980fca6188$export$dd44f18ab656f3bb = $3dcab9980fca6188$var$InjectJS;
 /* react Not a pure module */ 
});

parcelRegister("jWAMh", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $e84ff65ffd0d037b$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ePRCc = parcelRequire("ePRCc");

var $dJhID = parcelRequire("dJhID");

var $efwy1 = parcelRequire("efwy1");

var $1a0pQ = parcelRequire("1a0pQ");

var $hBcYV = parcelRequire("hBcYV");

var $1QuVJ = parcelRequire("1QuVJ");

var $3QcL7 = parcelRequire("3QcL7");

var $2ZaET = parcelRequire("2ZaET");

var $2X1gn = parcelRequire("2X1gn");

var $dhngN = parcelRequire("dhngN");

var $8adqh = parcelRequire("8adqh");

var $g7u7r = parcelRequire("g7u7r");

var $8E2YL = parcelRequire("8E2YL");
function $e84ff65ffd0d037b$var$NavMenuApp(Props) {
    var embedType = Props.embedType;
    var attributes = Props.attributes;
    var ctx = $3QcL7.use(undefined);
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var match$1 = $hBcYV.useRouter(undefined);
    var previewMode = match$1.previewMode;
    var goTo = match$1.goTo;
    var route = match$1.route;
    $efwy1.use(undefined);
    var items = $1a0pQ.useItems(undefined, undefined);
    var match$2 = $g85JO.useState(function() {});
    var setContentHeight = match$2[1];
    var contentHeight = match$2[0];
    var exitTimeoutRef = $g85JO.useRef(undefined);
    var handleMouseLeave = $g85JO.useCallback(function($$event) {
        $2whNH.forEach(exitTimeoutRef.current, function(prim) {
            clearTimeout(prim);
        });
        exitTimeoutRef.current = $loT9g.some(setTimeout(function(param) {
            if (typeof route === "number") return;
            switch(route.TAG | 0){
                case /* Home */ 0:
                case /* ListPage */ 1:
                    break;
                default:
                    return;
            }
            if ($7bjme.notequal(previewMode, /* PreviewHead */ 0)) return $iv6Yc._3(goTo, undefined, undefined, /* NotRendered */ 0);
        }, 50));
    }, [
        goTo
    ]);
    var handleMouseEnter = $g85JO.useCallback(function($$event) {
        $2whNH.forEach(exitTimeoutRef.current, function(prim) {
            clearTimeout(prim);
        });
    }, [
        goTo
    ]);
    var match$3 = ctx.mode;
    var tmp;
    if (match$3) {
        var tmp$1 = {};
        if (items !== undefined) tmp$1.items = $loT9g.valFromOption(items);
        tmp = /*#__PURE__*/ $g85JO.createElement($2X1gn.make, tmp$1);
    } else {
        var tmp$2 = {
            enableHiddenLinkTree: true,
            onMouseLeave: handleMouseLeave,
            onMouseEnter: handleMouseEnter
        };
        if (items !== undefined) tmp$2.items = $loT9g.valFromOption(items);
        tmp = /*#__PURE__*/ $g85JO.createElement($1QuVJ.make, tmp$2);
    }
    var match$4 = ctx.mode;
    var tmp$3 = {
        config: config,
        embedType: embedType,
        children: /*#__PURE__*/ $g85JO.createElement($dJhID.make, {
            componentName: "NavMenuApp",
            children: null
        }, tmp, /*#__PURE__*/ $g85JO.createElement($ePRCc.make, {
            initiator: "nav-menu-app",
            portal: true,
            children: match$4 ? /*#__PURE__*/ $g85JO.createElement($g7u7r.make, {
                contentHeight: contentHeight,
                setContentHeight: setContentHeight
            }) : /*#__PURE__*/ $g85JO.createElement($g7u7r.make, {
                contentHeight: contentHeight,
                setContentHeight: setContentHeight,
                onMouseLeave: handleMouseLeave,
                onMouseEnter: handleMouseEnter
            })
        }), /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
            condition: config.settings.cart,
            children: /*#__PURE__*/ $g85JO.createElement($8adqh.make, {})
        }))
    };
    if (attributes !== undefined) tmp$3.attributes = $loT9g.valFromOption(attributes);
    return /*#__PURE__*/ $g85JO.createElement($dhngN.make, tmp$3);
}
$e84ff65ffd0d037b$var$NavMenuApp.displayName = "NavMenuApp";
var $e84ff65ffd0d037b$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($e84ff65ffd0d037b$var$NavMenuApp);
var $e84ff65ffd0d037b$export$aa541d093b11ace2 = $e84ff65ffd0d037b$export$dd44f18ab656f3bb;
 /* make Not a pure module */ 
});
parcelRegister("dJhID", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $9fed38edae7c024d$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $6Tsgf = parcelRequire("6Tsgf");

var $hmsbi = parcelRequire("hmsbi");

var $hPrj9 = parcelRequire("hPrj9");

var $3GntQ = parcelRequire("3GntQ");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $75ZqT = parcelRequire("75ZqT");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $4QdUt = parcelRequire("4QdUt");
var $9fed38edae7c024d$export$20dc868c9a130faa = $75ZqT.$$Error.fromRescriptWithNewMessage;
var $9fed38edae7c024d$var$_ErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $hPrj9._)(_ErrorBoundary, _React_Component);
    var _super = (0, $3GntQ._)(_ErrorBoundary);
    function _ErrorBoundary(props) {
        (0, $6Tsgf._)(this, _ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: false,
            errorInfo: null
        };
        return _this;
    }
    (0, $hmsbi._)(_ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                // If we detect that the error is a rescript exception, we try to extract information out of it,
                // and create a new error object with it's RE_EXN_ID as the message.
                if (typeof error.RE_EXN_ID == "string" && typeof error.Error == "object") error = $9fed38edae7c024d$export$20dc868c9a130faa(error, error.RE_EXN_ID);
                // Do nothing if the error is thrown by parcel script loader.
                // This error usually indicates network issues.
                if (error.message.includes("Failed to fetch dynamically imported module:") || error.message.includes("Cannot find module") || error.message.includes("Could not resolve bundle with id")) return;
                this.setState({
                    error: error,
                    errorInfo: errorInfo
                });
                if (this.props.onError) this.props.onError(error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.error) return this.props.renderFallback ? this.props.renderFallback(this.state.error, this.state.errorInfo) : null;
                else return this.props.children;
            }
        }
    ]);
    return _ErrorBoundary;
}($g85JO.Component);
function $9fed38edae7c024d$var$ErrorBoundary$RawErrorBoundary(Props) {
    return /*#__PURE__*/ $g85JO.createElement($9fed38edae7c024d$var$_ErrorBoundary, Props);
}
$9fed38edae7c024d$var$ErrorBoundary$RawErrorBoundary.displayName = "ErrorBoundary.RawErrorBoundary";
var $9fed38edae7c024d$export$e022a45c7a286b77 = {
    make: $9fed38edae7c024d$var$ErrorBoundary$RawErrorBoundary
};
function $9fed38edae7c024d$export$b42e70ddca33ff5b(str) {
    if (str !== "") return str;
}
function $9fed38edae7c024d$var$ErrorBoundary$ReportOnce(Props) {
    var error = Props.error;
    var redirect = Props.redirect;
    var componentStack = Props.componentStack;
    var message = Props.message;
    $g85JO.useEffect(function() {
        $4QdUt.critical2(error, {
            message: message,
            componentStack: componentStack
        });
        var timeout = redirect !== undefined ? $loT9g.some(setTimeout(function(param) {
            $iv6Yc._1(redirect, undefined);
        }, 0)) : undefined;
        return function(param) {
            $2whNH.forEach(timeout, function(id) {
                clearTimeout(id);
            });
        };
    }, []);
    return null;
}
$9fed38edae7c024d$var$ErrorBoundary$ReportOnce.displayName = "ErrorBoundary.ReportOnce";
var $9fed38edae7c024d$export$f2fa74dfba7f4e57 = {
    make: $9fed38edae7c024d$var$ErrorBoundary$ReportOnce
};
function $9fed38edae7c024d$var$ErrorBoundary(Props) {
    var componentName = Props.componentName;
    var redirect = Props.redirect;
    var children = Props.children;
    var renderFallback = function renderFallback(internalError, info) {
        var cause = $75ZqT.$$Error.fromRescript(internalError);
        var rootCause = $75ZqT.$$Error.getRootCause(cause);
        var rootCauseName = rootCause.name;
        var rootCauseMessage = rootCause.message;
        var culprit = $2whNH.getWithDefault($2whNH.map($2whNH.flatMap($2whNH.map($2whNH.map($2whNH.flatMap($2whNH.map($2whNH.map(info.componentStack, function(__x) {
            return __x.replace(/\n/g, "");
        }), function(__x) {
            return __x.split(" in ");
        }), function(__x) {
            return $i7mYY.get(__x, 1);
        }), function(__x) {
            return __x.replace(/\(([^\)]+)\)/g, "");
        }), function(prim) {
            return prim.trim();
        }), $9fed38edae7c024d$export$b42e70ddca33ff5b), function(culprit) {
            return "<" + culprit + "> crashed, " + componentName + " caught";
        }), componentName + " caught a crash");
        var rootCauseMessage$1 = rootCauseName !== undefined ? rootCauseMessage !== undefined ? "RC: " + rootCauseName + " " + rootCauseMessage : "RC: " + rootCauseName : rootCauseMessage !== undefined ? "RC: " + rootCauseMessage : undefined;
        var message = $i7mYY.keepMap([
            culprit,
            rootCauseMessage$1
        ], function(a) {
            return a;
        }).join(", ");
        var error = $75ZqT.$$Error.fromStringWithCause(message, rootCause);
        var tmp = {
            error: error,
            componentStack: info.componentStack,
            message: message
        };
        if (redirect !== undefined) tmp.redirect = $loT9g.valFromOption(redirect);
        return /*#__PURE__*/ $g85JO.createElement($9fed38edae7c024d$var$ErrorBoundary$ReportOnce, tmp);
    };
    return /*#__PURE__*/ $g85JO.createElement($9fed38edae7c024d$var$ErrorBoundary$RawErrorBoundary, {
        children: children,
        renderFallback: renderFallback
    });
}
$9fed38edae7c024d$var$ErrorBoundary.displayName = "ErrorBoundary";
var $9fed38edae7c024d$export$dd44f18ab656f3bb = $9fed38edae7c024d$var$ErrorBoundary;
 /*  Not a pure module */ 
});

parcelRegister("1a0pQ", function(module, exports) {

$parcel$export(module.exports, "useItems", function () { return $0d870c36bac0af10$export$7bfdd97581ca93c; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $1xf0g = parcelRequire("1xf0g");

var $2jMpY = parcelRequire("2jMpY");

var $dzlIC = parcelRequire("dzlIC");

var $hBcYV = parcelRequire("hBcYV");

var $3QcL7 = parcelRequire("3QcL7");

var $8E2YL = parcelRequire("8E2YL");
function $0d870c36bac0af10$export$b42e70ddca33ff5b(a) {
    if (a.length === 0) return;
    else return a;
}
function $0d870c36bac0af10$export$7bfdd97581ca93c(root, param) {
    var match = $hBcYV.useRouter(undefined);
    var goTo = match.goTo;
    var match$1 = $8E2YL.use(undefined);
    var config = match$1.config;
    var ctx = $3QcL7.use(undefined);
    var isNested = function isNested(category) {
        return $2whNH.mapWithDefault(root, false, function(root) {
            return !$i7mYY.some($1xf0g.getChildren(root), function(c) {
                return c.id === category.id;
            });
        });
    };
    var categories = $g85JO.useMemo(function() {
        return $i7mYY.keep($i7mYY.concat($2whNH.mapWithDefault(root, [], function(root) {
            var newrecord = $7bjme.obj_dup(root);
            return [
                (newrecord.title = $2jMpY.concatWithoutRepeat("All", root.title), newrecord)
            ];
        }), $2whNH.getWithDefault($2whNH.map(root, function(root) {
            return $i7mYY.concatMany($i7mYY.map($1xf0g.getChildren(root), function(category) {
                if (ctx.threeColumnLayout) return [
                    category
                ];
                else return $i7mYY.concat([
                    category
                ], $1xf0g.getChildren(category));
            }));
        }), config.categories)), function(category) {
            if ($1xf0g.isIndexNode(category)) return ctx.isIndexAllowed;
            else return true;
        });
    }, [
        root,
        config.lastModifiedAt,
        ctx.mode
    ]);
    var pathMap = $g85JO.useMemo(function() {
        return $d3YYW.fromArray($i7mYY.map(categories, function(category) {
            return [
                category.id,
                $1xf0g.getCategoryPathById(config.categories, category.id)
            ];
        }));
    }, [
        categories
    ]);
    return $g85JO.useMemo(function() {
        return $2whNH.keep($i7mYY.map(categories, function(category) {
            var selfPath = $2whNH.getWithDefault($d3YYW.get(pathMap, category.id), []);
            var parent = $i7mYY.get($i7mYY.reverse(selfPath), 1);
            var match = $1xf0g.Link.getCardLink(category);
            var link;
            if (match !== undefined) switch(match.TAG | 0){
                case /* URL */ 0:
                    link = $1xf0g.hasAnyItems(category) ? /* NoLink */ 0 : {
                        TAG: /* ExternalLink */ 1,
                        _0: {
                            href: match._0,
                            label: category.title,
                            openInNewTab: config.settings.openLinkInNewTab,
                            category: category
                        }
                    };
                    break;
                case /* Product */ 2:
                    var match$1 = match._0;
                    var variantId = match$1.variantId;
                    var productId = match$1.productId;
                    link = {
                        TAG: /* InternalLink */ 0,
                        _0: function _0(e) {
                            $iv6Yc._3(goTo, undefined, undefined, {
                                TAG: /* PDP */ 2,
                                _0: {
                                    categoryId: undefined,
                                    productCategoryId: undefined,
                                    productId: productId,
                                    variantId: variantId,
                                    zoomedPhotoIndex: undefined
                                }
                            });
                        }
                    };
                    break;
                case /* Category */ 1:
                case /* StoreCategory */ 3:
                    link = /* NoLink */ 0;
                    break;
                case /* CustomAction */ 4:
                    var match$2 = match._0;
                    var name = match$2.name;
                    var code = match$2.code;
                    link = {
                        TAG: /* InternalLink */ 0,
                        _0: function _0(e) {
                            $dzlIC.triggerCustomFunctionWithoutProducts(code, name, undefined, undefined);
                        }
                    };
                    break;
            }
            else link = /* NoLink */ 0;
            return {
                category: category,
                parent: root !== undefined && root.id !== category.id ? root : undefined,
                isHidden: !category.visibleInMenuBar || $2whNH.mapWithDefault(parent, false, function(p) {
                    return !p.visibleInMenuBar;
                }),
                isNested: root !== undefined && root.id !== category.id ? isNested(category) : false,
                isIndex: category.id === "index",
                isParentItself: $2whNH.mapWithDefault(root, false, function(r) {
                    return r.id === category.id;
                }),
                link: link
            };
        }), function(items) {
            return items.length !== 0;
        });
    }, [
        categories
    ]);
}
 /* react Not a pure module */ 
});
parcelRegister("3QcL7", function(module, exports) {

$parcel$export(module.exports, "Provider", function () { return $2cc02018fede69bf$export$2881499e37b75b9a; });
$parcel$export(module.exports, "use", function () { return $2cc02018fede69bf$export$1f96ae73734a86cc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $1xf0g = parcelRequire("1xf0g");

var $ivJr2 = parcelRequire("ivJr2");

var $a8uU7 = parcelRequire("a8uU7");

var $hBcYV = parcelRequire("hBcYV");

var $8E2YL = parcelRequire("8E2YL");
var $2cc02018fede69bf$export$39f92e86d1722f3a = /*#__PURE__*/ $g85JO.createContext(undefined);
var $2cc02018fede69bf$var$provider = $2cc02018fede69bf$export$39f92e86d1722f3a.Provider;
function $2cc02018fede69bf$var$NavMenu__Context$Provider(Props) {
    var value = Props.value;
    var children = Props.children;
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, config.categories);
    var currentFullPath = $g85JO.useMemo(function() {
        if (activeCategory !== undefined) return $1xf0g.getCategoryPathById(config.categories, activeCategory.id);
        else return [];
    }, [
        activeCategory
    ]);
    var currentL1 = $i7mYY.get(currentFullPath, 0);
    var currentL2 = $i7mYY.get(currentFullPath, 1);
    var currentL3 = $i7mYY.get(currentFullPath, 2);
    var value$1 = $g85JO.useMemo(function() {
        return {
            mode: value.mode,
            currentFullPath: currentFullPath,
            currentL1: currentL1,
            currentL2: currentL2,
            currentL3: currentL3,
            pageFlipTransitionSpeedMs: value.pageFlipTransitionSpeedMs,
            modalTransitionSpeedMs: value.modalTransitionSpeedMs,
            modalBackdropHeight: value.modalBackdropHeight,
            modalBackdropOpacity: value.modalBackdropOpacity,
            modalMaxWidth: value.modalMaxWidth,
            zIndex: value.zIndex,
            maxLevels: value.maxLevels,
            positions: value.positions,
            threeColumnLayout: value.threeColumnLayout,
            isModalOpen: value.isModalOpen,
            isIndexAllowed: value.isIndexAllowed
        };
    }, [
        value,
        currentFullPath
    ]);
    return /*#__PURE__*/ $g85JO.createElement($2cc02018fede69bf$var$provider, {
        value: value$1,
        children: children
    });
}
$2cc02018fede69bf$var$NavMenu__Context$Provider.displayName = "NavMenu__Context.Provider";
var $2cc02018fede69bf$export$2881499e37b75b9a = {
    provider: $2cc02018fede69bf$var$provider,
    make: $2cc02018fede69bf$var$NavMenu__Context$Provider
};
function $2cc02018fede69bf$export$1f96ae73734a86cc(param) {
    return $ivJr2.useWithDefault("NavMenu__Context.use", "NavMenu__Context.Provider", $2cc02018fede69bf$export$39f92e86d1722f3a, $a8uU7.emptyCtx);
}
var $2cc02018fede69bf$export$f36c9b20522c59e3;
 /* ctx Not a pure module */ 
});
parcelRegister("a8uU7", function(module, exports) {

$parcel$export(module.exports, "emptyCtx", function () { return $76129fa79a482baa$export$369836a8f840b34c; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $cTjaa = parcelRequire("cTjaa");
var $76129fa79a482baa$export$3cea7b014ae8db7f = {
    modalTop: 0,
    modalMaxHeight: 0,
    siteHeaderSize: $cTjaa.empty
};
var $76129fa79a482baa$var$emptyCtx_currentFullPath = [];
var $76129fa79a482baa$export$369836a8f840b34c = {
    mode: /* Topbar */ 0,
    currentFullPath: $76129fa79a482baa$var$emptyCtx_currentFullPath,
    currentL1: undefined,
    currentL2: undefined,
    currentL3: undefined,
    pageFlipTransitionSpeedMs: 250,
    modalTransitionSpeedMs: 150,
    modalBackdropHeight: 50,
    modalBackdropOpacity: 0.5,
    modalMaxWidth: 480,
    zIndex: 0,
    maxLevels: 4,
    positions: $76129fa79a482baa$export$3cea7b014ae8db7f,
    threeColumnLayout: false,
    isModalOpen: false,
    isIndexAllowed: false
};
 /* ResizeObserver-Showside Not a pure module */ 
});



parcelRegister("1QuVJ", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $1582a3d530a14acf$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $1xf0g = parcelRequire("1xf0g");

var $95jr3 = parcelRequire("95jr3");

var $gCzsf = parcelRequire("gCzsf");

var $5bEXW = parcelRequire("5bEXW");

var $7EFoE = parcelRequire("7EFoE");

var $1aE5A = parcelRequire("1aE5A");

var $3QcL7 = parcelRequire("3QcL7");

var $9pMGg = parcelRequire("9pMGg");

var $9Whwx = parcelRequire("9Whwx");

var $8E2YL = parcelRequire("8E2YL");
function $1582a3d530a14acf$var$NavMenu__Topbar$HiddenLinkTree(Props) {
    var category = Props.category;
    var renderGroup = function renderGroup1(index, children) {
        if (children.length === 0) return null;
        else return /*#__PURE__*/ $g85JO.createElement("ul", {
            key: String(index),
            className: $ezf3v.prefix("sr-only")
        }, $i7mYY.mapWithIndex($i7mYY.keepMap(children, function(child) {
            var childrenOfChild = $1xf0g.getChildren(child);
            return $2whNH.map($1xf0g.getCategoryLink(child), function(link) {
                return [
                    link,
                    child.title,
                    childrenOfChild
                ];
            });
        }), function(i, param) {
            return /*#__PURE__*/ $g85JO.createElement("li", {
                key: String(i),
                className: $ezf3v.prefix("sr-only")
            }, /*#__PURE__*/ $g85JO.createElement("a", {
                className: $ezf3v.prefix("sr-only"),
                tabIndex: -1,
                href: param[0]
            }, param[1]), renderGroup(index + 1 | 0, param[2]));
        }));
    };
    return renderGroup(1, $1xf0g.getChildren(category));
}
$1582a3d530a14acf$var$NavMenu__Topbar$HiddenLinkTree.displayName = "NavMenu__Topbar.HiddenLinkTree";
var $1582a3d530a14acf$var$make = /*#__PURE__*/ $g85JO.memo($1582a3d530a14acf$var$NavMenu__Topbar$HiddenLinkTree);
var $1582a3d530a14acf$export$a1c5f0079a6f2a52 = {
    make: $1582a3d530a14acf$var$make
};
function $1582a3d530a14acf$var$NavMenu__Topbar$Item(Props) {
    var category = Props.category;
    var link = Props.link;
    var enableHiddenLinkTree = Props.enableHiddenLinkTree;
    var match = $8E2YL.use(undefined);
    var match$1 = $9pMGg.use(undefined);
    var onPureCategoryClick = match$1.onPureCategoryClick;
    var trackEvent = match$1.trackEvent;
    var ctx = $3QcL7.use(undefined);
    var ref = $g85JO.useRef(null);
    var emptyRef = $g85JO.useRef(null);
    var isScrolling = $7EFoE.useIsScrolling(150, emptyRef);
    var isActive = $2whNH.mapWithDefault(ctx.currentL1, false, function(c) {
        return c.id === category.id;
    });
    var match$2 = ctx.mode;
    var match$3 = $1aE5A.useDelayedHover(!ctx.isModalOpen, 100, match$2 || !(typeof link === "number" && !isScrolling) ? undefined : function(param) {
        $iv6Yc._2(onPureCategoryClick, false, category);
    });
    var handleItemMouseEnter = match$3.onMouseEnter;
    var match$4 = $9Whwx.useTouch(true, undefined, function(e) {
        $iv6Yc._2(onPureCategoryClick, undefined, category);
    });
    var match$5 = ctx.mode;
    var handleItemTouchStart = typeof link === "number" && !match$5 ? match$4.onTouchStart : undefined;
    var match$6 = ctx.mode;
    var handleItemTouchMove = typeof link === "number" && !match$6 ? match$4.onTouchMove : undefined;
    var match$7 = ctx.mode;
    var handleItemTouchEnd = typeof link === "number" && !match$7 ? match$4.onTouchEnd : undefined;
    var tmp;
    tmp = typeof link === "number" || link.TAG === /* InternalLink */ 0 ? undefined : link._0.href;
    var href = $2whNH.orElse($2whNH.flatMap($1xf0g.Link.getCardFallbackLink(category), $1xf0g.Link.getURL), tmp);
    var handleItemClick = function handleItemClick(e) {
        var match = ctx.mode;
        if (typeof link === "number" && match) e.preventDefault();
        var match$1 = ctx.mode;
        if (typeof link === "number") {
            if (match$1) return $iv6Yc._2(onPureCategoryClick, undefined, category);
        } else if (link.TAG === /* InternalLink */ 0) return $iv6Yc._1(link._0, undefined);
        $iv6Yc.app(trackEvent, [
            "menu:link clicked",
            undefined,
            category,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
    };
    var target = match.config.settings.openLinkInNewTab ? "_blank" : undefined;
    var match$8 = ctx.mode;
    var tmp$1 = {
        ref: $5bEXW.Ref.domRef(ref),
        className: $ezf3v.prefix($1TRFX.make([
            "p-0.5",
            "no-underline",
            "text-color-unset",
            "whitespace-nowrap",
            match$8 ? "border-b-2" : "border-b-3",
            link !== /* NoLink */ 0 ? "hover:underline" : "",
            "outline-none flex h-full items-center select-none",
            $2whNH.isSome(href) ? "cursor-pointer" : "cursor-default",
            isActive ? "border-accent" : ctx.mode === /* Topbar */ 0 && handleItemMouseEnter !== undefined && href === undefined ? "border-transparent hover:border-accent" : "border-transparent"
        ])),
        draggable: false,
        tabIndex: 0,
        onClick: handleItemClick,
        onMouseLeave: match$3.onMouseLeave
    };
    if (href !== undefined) tmp$1.href = $loT9g.valFromOption(href);
    if (target !== undefined) tmp$1.target = $loT9g.valFromOption(target);
    if (handleItemMouseEnter !== undefined) tmp$1.onMouseEnter = $loT9g.valFromOption(handleItemMouseEnter);
    if (handleItemTouchEnd !== undefined) tmp$1.onTouchEnd = $loT9g.valFromOption(handleItemTouchEnd);
    if (handleItemTouchMove !== undefined) tmp$1.onTouchMove = $loT9g.valFromOption(handleItemTouchMove);
    if (handleItemTouchStart !== undefined) tmp$1.onTouchStart = $loT9g.valFromOption(handleItemTouchStart);
    return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "nav-menu-topbar-item",
        children: /*#__PURE__*/ $g85JO.createElement("a", tmp$1, /*#__PURE__*/ $g85JO.createElement("span", undefined, category.title))
    }), enableHiddenLinkTree ? /*#__PURE__*/ $g85JO.createElement($1582a3d530a14acf$var$make, {
        category: category
    }) : null);
}
$1582a3d530a14acf$var$NavMenu__Topbar$Item.displayName = "NavMenu__Topbar.Item";
var $1582a3d530a14acf$export$6d08773d2e66f8f2 = {
    make: $1582a3d530a14acf$var$NavMenu__Topbar$Item
};
function $1582a3d530a14acf$var$NavMenu__Topbar(Props) {
    var itemsOpt = Props.items;
    var classNameOpt = Props.className;
    var offsetOpt = Props.offset;
    var hideOnEmptyOpt = Props.hideOnEmpty;
    var centeredOpt = Props.centered;
    var enableHiddenLinkTreeOpt = Props.enableHiddenLinkTree;
    var onMouseLeave = Props.onMouseLeave;
    var onMouseEnter = Props.onMouseEnter;
    var items = itemsOpt !== undefined ? itemsOpt : [];
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var offset = offsetOpt !== undefined ? offsetOpt : 0;
    var hideOnEmpty = hideOnEmptyOpt !== undefined ? hideOnEmptyOpt : false;
    var centered = centeredOpt !== undefined ? centeredOpt : true;
    var enableHiddenLinkTree = enableHiddenLinkTreeOpt !== undefined ? enableHiddenLinkTreeOpt : false;
    $8E2YL.use(undefined);
    var ctx = $3QcL7.use(undefined);
    var scrollableRef = $g85JO.useRef(null);
    var items$1 = $i7mYY.keep(items, function(item) {
        return !item.isHidden;
    });
    var isEmpty = $i7mYY.keep(items$1, function(item) {
        return !item.isIndex;
    }).length === 0;
    var slides = $i7mYY.map(items$1, function(param) {
        var category = param.category;
        return /*#__PURE__*/ $g85JO.createElement($1582a3d530a14acf$var$NavMenu__Topbar$Item, {
            category: category,
            link: param.link,
            enableHiddenLinkTree: enableHiddenLinkTree,
            scrollableRef: scrollableRef,
            key: category.id
        });
    });
    var activeItemIndex = $i7mYY.getIndexBy(items$1, function(item) {
        return $7bjme.equal(item.category.id, $2whNH.map(ctx.currentL1, function(c) {
            return c.id;
        }));
    });
    var match = $g85JO.useState(function() {});
    var setActiveItemIndexDelayed = match[1];
    var activeItemIndexDelayed = match[0];
    $g85JO.useEffect(function() {
        var timeout = setTimeout(function(param) {
            $iv6Yc._1(setActiveItemIndexDelayed, function(param) {
                return activeItemIndex;
            });
        }, 0);
        return function(param) {
            clearTimeout(timeout);
        };
    }, [
        activeItemIndex
    ]);
    var slideToIndexRef = $g85JO.useRef(function(param) {});
    $g85JO.useEffect(function() {
        var match = ctx.mode;
        if (match && activeItemIndexDelayed !== undefined) $iv6Yc._1(slideToIndexRef.current, activeItemIndexDelayed);
    }, [
        activeItemIndexDelayed
    ]);
    if (isEmpty && hideOnEmpty) return null;
    var tmp = {
        className: $1TRFX.make([
            "swiper-small-navigation",
            $ezf3v.prefix("h-full flex items-center")
        ])
    };
    if (onMouseEnter !== undefined) tmp.onMouseEnter = $loT9g.valFromOption(onMouseEnter);
    if (onMouseLeave !== undefined) tmp.onMouseLeave = $loT9g.valFromOption(onMouseLeave);
    var match$1 = ctx.mode;
    return /*#__PURE__*/ $g85JO.createElement("div", tmp, /*#__PURE__*/ $g85JO.createElement($95jr3.make, {
        slides: slides,
        slidesOffsetBefore: offset,
        slidesOffsetAfter: offset,
        shouldCenter: centered,
        className: $ezf3v.prefix("w-full"),
        ulClassName: $1TRFX.make([
            match$1 ? $ezf3v.prefix("space-x-3") : $ezf3v.prefix("space-x-6"),
            className
        ]),
        fwdRef: scrollableRef,
        slideToIndexRef: slideToIndexRef
    }));
}
$1582a3d530a14acf$var$NavMenu__Topbar.displayName = "NavMenu__Topbar";
var $1582a3d530a14acf$export$1fad8eb4ccf1af8f = 100;
var $1582a3d530a14acf$export$dd44f18ab656f3bb = $1582a3d530a14acf$var$NavMenu__Topbar;
 /* make Not a pure module */ 
});
parcelRegister("7EFoE", function(module, exports) {

$parcel$export(module.exports, "useIsScrolling", function () { return $592c6150cfde6e05$export$fde36fcfab14caba; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $g0DOt = parcelRequire("g0DOt");
function $592c6150cfde6e05$export$fde36fcfab14caba(debounceMsOpt, containerRef) {
    var debounceMs = debounceMsOpt !== undefined ? debounceMsOpt : 500;
    var match = $g85JO.useState(function() {
        return false;
    });
    var setScrolling = match[1];
    var container = $2whNH.getWithDefault($loT9g.nullable_to_opt(containerRef.current), window);
    var handleEndScroll = $g85JO.useMemo(function() {
        return (0, $g0DOt.default)(function(param) {
            $iv6Yc._1(setScrolling, function(param) {
                return false;
            });
        }, debounceMs);
    }, []);
    var handleScrolling = $g85JO.useCallback(function(param) {
        $iv6Yc._1(setScrolling, function(i) {
            return true;
        });
        return $iv6Yc._1(handleEndScroll, undefined);
    }, [
        setScrolling
    ]);
    $g85JO.useEffect(function() {
        container.addEventListener("scroll", handleScrolling);
        return function(param) {
            container.removeEventListener("scroll", handleScrolling);
        };
    }, []);
    return match[0];
}
 /* react Not a pure module */ 
});
parcelRegister("g0DOt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba7b877d63b6054e$export$2e2bcd8739ae039; });

var $iYlcu = parcelRequire("iYlcu");

var $92qkg = parcelRequire("92qkg");

var $flcGD = parcelRequire("flcGD");
/** Error message constants. */ var $ba7b877d63b6054e$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ba7b877d63b6054e$var$nativeMax = Math.max, $ba7b877d63b6054e$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $ba7b877d63b6054e$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($ba7b877d63b6054e$var$FUNC_ERROR_TEXT);
    wait = (0, $flcGD.default)(wait) || 0;
    if ((0, $iYlcu.default)(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $ba7b877d63b6054e$var$nativeMax((0, $flcGD.default)(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $ba7b877d63b6054e$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $92qkg.default)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $92qkg.default)());
    }
    function debounced() {
        var time = (0, $92qkg.default)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $ba7b877d63b6054e$export$2e2bcd8739ae039 = $ba7b877d63b6054e$var$debounce;

});
parcelRegister("iYlcu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $dcfe469055918527$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ 
var $gfRPo = parcelRequire("gfRPo");
function $dcfe469055918527$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $gfRPo._)(value);
    return value != null && (type == "object" || type == "function");
}
var $dcfe469055918527$export$2e2bcd8739ae039 = $dcfe469055918527$var$isObject;

});

parcelRegister("92qkg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6948b8bba5c9c483$export$2e2bcd8739ae039; });

var $enmTs = parcelRequire("enmTs");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $6948b8bba5c9c483$var$now = function now() {
    return (0, $enmTs.default).Date.now();
};
var $6948b8bba5c9c483$export$2e2bcd8739ae039 = $6948b8bba5c9c483$var$now;

});
parcelRegister("enmTs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $02b36f5e631d88f5$export$2e2bcd8739ae039; });

var $igP3b = parcelRequire("igP3b");
/** Detect free variable `self`. */ var $02b36f5e631d88f5$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $02b36f5e631d88f5$var$root = (0, $igP3b.default) || $02b36f5e631d88f5$var$freeSelf || Function("return this")();
var $02b36f5e631d88f5$export$2e2bcd8739ae039 = $02b36f5e631d88f5$var$root;

});
parcelRegister("igP3b", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d4d152269e8defce$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $d4d152269e8defce$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $d4d152269e8defce$export$2e2bcd8739ae039 = $d4d152269e8defce$var$freeGlobal;

});



parcelRegister("flcGD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2b2a881acb233f6$export$2e2bcd8739ae039; });

var $7bKHP = parcelRequire("7bKHP");

var $iYlcu = parcelRequire("iYlcu");

var $9WZwf = parcelRequire("9WZwf");
/** Used as references for various `Number` constants. */ var $b2b2a881acb233f6$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $b2b2a881acb233f6$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $b2b2a881acb233f6$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $b2b2a881acb233f6$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $b2b2a881acb233f6$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $b2b2a881acb233f6$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ((0, $9WZwf.default)(value)) return $b2b2a881acb233f6$var$NAN;
    if ((0, $iYlcu.default)(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = (0, $iYlcu.default)(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = (0, $7bKHP.default)(value);
    var isBinary = $b2b2a881acb233f6$var$reIsBinary.test(value);
    return isBinary || $b2b2a881acb233f6$var$reIsOctal.test(value) ? $b2b2a881acb233f6$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $b2b2a881acb233f6$var$reIsBadHex.test(value) ? $b2b2a881acb233f6$var$NAN : +value;
}
var $b2b2a881acb233f6$export$2e2bcd8739ae039 = $b2b2a881acb233f6$var$toNumber;

});
parcelRegister("7bKHP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53bdca4c640065b2$export$2e2bcd8739ae039; });

var $hVIkI = parcelRequire("hVIkI");
/** Used to match leading whitespace. */ var $53bdca4c640065b2$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $53bdca4c640065b2$var$baseTrim(string) {
    return string ? string.slice(0, (0, $hVIkI.default)(string) + 1).replace($53bdca4c640065b2$var$reTrimStart, "") : string;
}
var $53bdca4c640065b2$export$2e2bcd8739ae039 = $53bdca4c640065b2$var$baseTrim;

});
parcelRegister("hVIkI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d0da26260aa88ea2$export$2e2bcd8739ae039; });
/** Used to match a single whitespace character. */ var $d0da26260aa88ea2$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $d0da26260aa88ea2$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $d0da26260aa88ea2$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $d0da26260aa88ea2$export$2e2bcd8739ae039 = $d0da26260aa88ea2$var$trimmedEndIndex;

});


parcelRegister("9WZwf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $73e9403b864b7e92$export$2e2bcd8739ae039; });

var $gfRPo = parcelRequire("gfRPo");

var $gEvC5 = parcelRequire("gEvC5");

var $2pW4B = parcelRequire("2pW4B");
/** `Object#toString` result references. */ var $73e9403b864b7e92$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $73e9403b864b7e92$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $gfRPo._)(value)) == "symbol" || (0, $2pW4B.default)(value) && (0, $gEvC5.default)(value) == $73e9403b864b7e92$var$symbolTag;
}
var $73e9403b864b7e92$export$2e2bcd8739ae039 = $73e9403b864b7e92$var$isSymbol;

});
parcelRegister("gEvC5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1f8e78702c28b95$export$2e2bcd8739ae039; });

var $155hF = parcelRequire("155hF");

var $drSKx = parcelRequire("drSKx");

var $gu259 = parcelRequire("gu259");
/** `Object#toString` result references. */ var $c1f8e78702c28b95$var$nullTag = "[object Null]", $c1f8e78702c28b95$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $c1f8e78702c28b95$var$symToStringTag = (0, $155hF.default) ? (0, $155hF.default).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $c1f8e78702c28b95$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $c1f8e78702c28b95$var$undefinedTag : $c1f8e78702c28b95$var$nullTag;
    return $c1f8e78702c28b95$var$symToStringTag && $c1f8e78702c28b95$var$symToStringTag in Object(value) ? (0, $drSKx.default)(value) : (0, $gu259.default)(value);
}
var $c1f8e78702c28b95$export$2e2bcd8739ae039 = $c1f8e78702c28b95$var$baseGetTag;

});
parcelRegister("155hF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0c9a5b621e5301b6$export$2e2bcd8739ae039; });

var $enmTs = parcelRequire("enmTs");
/** Built-in value references. */ var $0c9a5b621e5301b6$var$Symbol = (0, $enmTs.default).Symbol;
var $0c9a5b621e5301b6$export$2e2bcd8739ae039 = $0c9a5b621e5301b6$var$Symbol;

});

parcelRegister("drSKx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9ca84417f00d2331$export$2e2bcd8739ae039; });

var $155hF = parcelRequire("155hF");
/** Used for built-in method references. */ var $9ca84417f00d2331$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9ca84417f00d2331$var$hasOwnProperty = $9ca84417f00d2331$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $9ca84417f00d2331$var$nativeObjectToString = $9ca84417f00d2331$var$objectProto.toString;
/** Built-in value references. */ var $9ca84417f00d2331$var$symToStringTag = (0, $155hF.default) ? (0, $155hF.default).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $9ca84417f00d2331$var$getRawTag(value) {
    var isOwn = $9ca84417f00d2331$var$hasOwnProperty.call(value, $9ca84417f00d2331$var$symToStringTag), tag = value[$9ca84417f00d2331$var$symToStringTag];
    try {
        value[$9ca84417f00d2331$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $9ca84417f00d2331$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$9ca84417f00d2331$var$symToStringTag] = tag;
        else delete value[$9ca84417f00d2331$var$symToStringTag];
    }
    return result;
}
var $9ca84417f00d2331$export$2e2bcd8739ae039 = $9ca84417f00d2331$var$getRawTag;

});

parcelRegister("gu259", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0011029f37088ab$export$2e2bcd8739ae039; });
/** Used for built-in method references. */ var $c0011029f37088ab$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $c0011029f37088ab$var$nativeObjectToString = $c0011029f37088ab$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $c0011029f37088ab$var$objectToString(value) {
    return $c0011029f37088ab$var$nativeObjectToString.call(value);
}
var $c0011029f37088ab$export$2e2bcd8739ae039 = $c0011029f37088ab$var$objectToString;

});


parcelRegister("2pW4B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1c2af6b3f01b3b43$export$2e2bcd8739ae039; });
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $1c2af6b3f01b3b43$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $1c2af6b3f01b3b43$export$2e2bcd8739ae039 = $1c2af6b3f01b3b43$var$isObjectLike;

});





parcelRegister("1aE5A", function(module, exports) {

$parcel$export(module.exports, "useDelayedHover", function () { return $0da5d27f96f161e6$export$7771a820816ce7f1; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");
function $0da5d27f96f161e6$export$7771a820816ce7f1(enabledOpt, delay, onHover) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var hoverTimeout = $g85JO.useRef(undefined);
    var $$clearTimeout$1 = function $$clearTimeout$1(param) {
        $2whNH.forEach(hoverTimeout.current, function(timeout) {
            clearTimeout(timeout);
            hoverTimeout.current = undefined;
        });
    };
    var handleMouseEnter = $2whNH.map(onHover, function(onHover, $$event) {
        $$clearTimeout$1(undefined);
        if (enabled) {
            hoverTimeout.current = $loT9g.some(setTimeout(function(param) {
                $iv6Yc._1(onHover, $$event);
            }, delay));
            return;
        } else return $iv6Yc._1(onHover, $$event);
    });
    var handleMouseLeave = function handleMouseLeave(param) {
        $$clearTimeout$1(undefined);
    };
    $g85JO.useEffect(function() {
        return $$clearTimeout$1;
    }, []);
    return {
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave
    };
}
 /* react Not a pure module */ 
});

parcelRegister("9Whwx", function(module, exports) {

$parcel$export(module.exports, "useTouch", function () { return $73c71fb48baf82c1$export$72022e98e0a26546; });
$parcel$export(module.exports, "useMouse", function () { return $73c71fb48baf82c1$export$70811b4970b0f258; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");
function $73c71fb48baf82c1$export$72022e98e0a26546(preventDefaultOpt, stopPropagationOpt, onTouchEnd) {
    var preventDefault = preventDefaultOpt !== undefined ? preventDefaultOpt : false;
    var stopPropagation = stopPropagationOpt !== undefined ? stopPropagationOpt : false;
    var hasTouchMovedRef = $g85JO.useRef(false);
    var onTouchStart = function onTouchStart(e) {
        if (preventDefault) e.preventDefault();
        if (stopPropagation) e.stopPropagation();
        hasTouchMovedRef.current = false;
    };
    var onTouchMove = function onTouchMove(e) {
        if (preventDefault) e.preventDefault();
        if (stopPropagation) e.stopPropagation();
        hasTouchMovedRef.current = true;
    };
    var onTouchEnd$1 = function onTouchEnd$1(e) {
        if (hasTouchMovedRef.current) return;
        else {
            if (preventDefault) e.preventDefault();
            if (stopPropagation) e.stopPropagation();
            return $iv6Yc._1(onTouchEnd, e);
        }
    };
    return {
        onTouchStart: onTouchStart,
        onTouchMove: onTouchMove,
        onTouchEnd: onTouchEnd$1
    };
}
function $73c71fb48baf82c1$export$70811b4970b0f258(preventDefaultOpt, stopPropagationOpt, onMouseUp) {
    var preventDefault = preventDefaultOpt !== undefined ? preventDefaultOpt : false;
    var stopPropagation = stopPropagationOpt !== undefined ? stopPropagationOpt : false;
    var isMouseDownRef = $g85JO.useRef(false);
    var onMouseDown = function onMouseDown(e) {
        if (preventDefault) e.preventDefault();
        if (stopPropagation) e.stopPropagation();
        isMouseDownRef.current = true;
    };
    var onMouseLeave = function onMouseLeave(e) {
        isMouseDownRef.current = false;
    };
    var onMouseUp$1 = function onMouseUp$1(e) {
        if (isMouseDownRef.current) {
            if (preventDefault) e.preventDefault();
            if (stopPropagation) e.stopPropagation();
            $iv6Yc._1(onMouseUp, e);
        }
        isMouseDownRef.current = false;
    };
    return {
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp$1,
        onMouseLeave: onMouseLeave
    };
}
 /* react Not a pure module */ 
});


parcelRegister("2X1gn", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $2262124ab9789adb$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $7wIsS = parcelRequire("7wIsS");

var $gCzsf = parcelRequire("gCzsf");

var $5bEXW = parcelRequire("5bEXW");

var $9pMGg = parcelRequire("9pMGg");

var $9Whwx = parcelRequire("9Whwx");

var $8E2YL = parcelRequire("8E2YL");
function $2262124ab9789adb$var$NavMenu__Hamburger$Item(Props) {
    var category = Props.category;
    var link = Props.link;
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var match$1 = $9pMGg.use(undefined);
    var onPureCategoryClick = match$1.onPureCategoryClick;
    var trackEvent = match$1.trackEvent;
    var ref = $g85JO.useRef(null);
    var href;
    href = typeof link === "number" || link.TAG === /* InternalLink */ 0 ? undefined : link._0.href;
    var handleOnClick = function handleOnClick(param) {
        if (typeof link === "number") return $iv6Yc._2(onPureCategoryClick, undefined, category);
        else if (link.TAG === /* InternalLink */ 0) return $iv6Yc._1(link._0, undefined);
        else return $iv6Yc.app(trackEvent, [
            "menu:link clicked",
            undefined,
            category,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
    };
    var match$2 = $9Whwx.useMouse(undefined, undefined, handleOnClick);
    var target;
    target = typeof link === "number" ? config.settings.openLinkInNewTab ? "_blank" : undefined : link.TAG === /* InternalLink */ 0 ? config.settings.openLinkInNewTab ? "_blank" : undefined : link._0.openInNewTab ? "_blank" : undefined;
    var tmp;
    tmp = typeof link === "number" || link.TAG === /* InternalLink */ 0 ? "" : "underline";
    var tmp$1 = {
        ref: $5bEXW.Ref.domRef(ref),
        className: $ezf3v.prefix($1TRFX.make([
            "outline-none flex items-center select-none",
            "text-color-unset",
            "py-6 px-4",
            "cursor-default",
            tmp
        ])),
        tabIndex: 0,
        onClick: handleOnClick,
        onMouseDown: match$2.onMouseDown,
        onMouseLeave: match$2.onMouseLeave,
        onMouseUp: match$2.onMouseUp
    };
    if (href !== undefined) tmp$1.href = $loT9g.valFromOption(href);
    if (target !== undefined) tmp$1.target = $loT9g.valFromOption(target);
    var tmp$2;
    var exit = 0;
    if (typeof link === "number" || link.TAG === /* InternalLink */ 0) exit = 1;
    else tmp$2 = null;
    if (exit === 1) tmp$2 = /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("opacity-50")
    }, /*#__PURE__*/ $g85JO.createElement($7wIsS.UilAngleRightB.make, {
        size: /* Px */ {
            _0: 18
        }
    }));
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "nav-menu-hamburger-item",
        children: /*#__PURE__*/ $g85JO.createElement("li", undefined, /*#__PURE__*/ $g85JO.createElement("a", tmp$1, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("flex-grow truncate-lines truncate-lines-1")
        }, category.title), tmp$2))
    });
}
$2262124ab9789adb$var$NavMenu__Hamburger$Item.displayName = "NavMenu__Hamburger.Item";
var $2262124ab9789adb$export$6d08773d2e66f8f2 = {
    make: $2262124ab9789adb$var$NavMenu__Hamburger$Item
};
function $2262124ab9789adb$var$NavMenu__Hamburger(Props) {
    var itemsOpt = Props.items;
    var items = itemsOpt !== undefined ? itemsOpt : [];
    var renderWithDividers = function renderWithDividers(els) {
        return $i7mYY.concatMany($i7mYY.mapWithIndex(els, function(i, e) {
            if (i === 0) return [
                e
            ];
            else return [
                /*#__PURE__*/ $g85JO.createElement("div", {
                    key: String(i),
                    className: $ezf3v.prefix("opacity-5 border-t border-current w-full")
                }),
                e
            ];
        }));
    };
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "nav-menu-hamburger",
        children: /*#__PURE__*/ $g85JO.createElement("ul", {
            className: $ezf3v.prefix($1TRFX.make([
                "list-none justify-center",
                "w-full max-h-full",
                "overflow-auto",
                "p-0 m-0"
            ]))
        }, renderWithDividers($i7mYY.map($i7mYY.keep(items, function(param) {
            return !param.isHidden;
        }), function(param) {
            var category = param.category;
            return /*#__PURE__*/ $g85JO.createElement($2262124ab9789adb$var$NavMenu__Hamburger$Item, {
                category: category,
                link: param.link,
                key: category.id
            });
        })))
    });
}
$2262124ab9789adb$var$NavMenu__Hamburger.displayName = "NavMenu__Hamburger";
var $2262124ab9789adb$export$dd44f18ab656f3bb = $2262124ab9789adb$var$NavMenu__Hamburger;
 /* react Not a pure module */ 
});

parcelRegister("8adqh", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $5f19ab6e1e369baa$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $5f19ab6e1e369baa$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("7YjQi"));
});
function $5f19ab6e1e369baa$var$MiniCartDrawer_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($5f19ab6e1e369baa$var$component, Props);
}
$5f19ab6e1e369baa$var$MiniCartDrawer_Lazy.displayName = "MiniCartDrawer_Lazy";
var $5f19ab6e1e369baa$export$dd44f18ab656f3bb = $5f19ab6e1e369baa$var$MiniCartDrawer_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("7YjQi", function(module, exports) {










module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aGl6m")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("1QPUT")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("bumwY")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("ebd07"))
]).then(function() {
    return parcelRequire("67Br4");
});

});


parcelRegister("g7u7r", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $bbc4a9cab9665658$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $7tAuM = parcelRequire("7tAuM");

var $bbc4a9cab9665658$var$component = (0, $7tAuM.default)(function() {
    return (parcelRequire("6glUJ"));
});
function $bbc4a9cab9665658$var$NavMenuOverlay_Lazy(Props) {
    return /*#__PURE__*/ $g85JO.createElement($bbc4a9cab9665658$var$component, Props);
}
$bbc4a9cab9665658$var$NavMenuOverlay_Lazy.displayName = "NavMenuOverlay_Lazy";
var $bbc4a9cab9665658$export$513ccb98c53b8039 = $bbc4a9cab9665658$var$component.preload;
var $bbc4a9cab9665658$export$dd44f18ab656f3bb = $bbc4a9cab9665658$var$NavMenuOverlay_Lazy;
 /*  Not a pure module */ 
});
parcelRegister("6glUJ", function(module, exports) {
















module.exports = Promise.all([
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("iw4cu")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("9j6sg")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("6zo4Z")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("aGl6m")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("1QPUT")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("bumwY")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("fbQqy")),
    (parcelRequire("isbc1"))((parcelRequire("7wgKE")).resolve("8bhks"))
]).then(function() {
    return parcelRequire("g7Te6");
});

});



parcelRegister("i6QHm", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $d2f1aa58c533da63$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $9rqV0 = parcelRequire("9rqV0");

var $b5aRK = parcelRequire("b5aRK");

var $iCVlB = parcelRequire("iCVlB");
function $d2f1aa58c533da63$var$AdditionalCSS(Props) {
    var embedType = Props.embedType;
    var getIsNavBeingHiddenWithDisplayNone = function getIsNavBeingHiddenWithDisplayNone(param) {
        return $i7mYY.every($i7mYY.map($i7mYY.map(Array.prototype.slice.call(document.querySelectorAll("#" + $9rqV0.getIdByEmbedType(embedType))), $b5aRK.ofNode), function(node) {
            return $2whNH.map(node, function(node) {
                return window.getComputedStyle(node).display;
            });
        }), function(display) {
            return $7bjme.equal(display, "none");
        });
    };
    var match = $g85JO.useState(function() {
        return getIsNavBeingHiddenWithDisplayNone(undefined);
    });
    var setIsNavBeingHiddenWithDisplayNone = match[1];
    $g85JO.useLayoutEffect(function() {
        $iv6Yc._1(setIsNavBeingHiddenWithDisplayNone, function(param) {
            return getIsNavBeingHiddenWithDisplayNone(undefined);
        });
    });
    if (match[0]) return null;
    else return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, /*#__PURE__*/ $g85JO.createElement("style", undefined, "html[lang='en'].QVTW__body-no-scroll body,\n        html.QVTW__body-no-scroll,\n        html[lang='en'].QVTW__body-no-scroll body.production,\n        html.QVTW__body-no-scroll,\n        html.QVTW__body-no-scroll body {\n          overflow: clip !important;\n          overflow-x: clip !important;\n          overflow-y: clip !important;\n          touch-action: none;\n        }\n\n        html.QVTW__body-no-scroll .js-maker-embed[data-sticky] iframe {\n          display: none !important;\n        }"), /*#__PURE__*/ $g85JO.createElement($iCVlB.CustomStyling.make, {}));
}
$d2f1aa58c533da63$var$AdditionalCSS.displayName = "AdditionalCSS";
var $d2f1aa58c533da63$export$dd44f18ab656f3bb = $d2f1aa58c533da63$var$AdditionalCSS;
 /* react Not a pure module */ 
});

parcelRegister("4j4tH", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $322c68ffe6f8f794$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2gEz2 = parcelRequire("2gEz2");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $baORH = parcelRequire("baORH");

var $i7mYY = parcelRequire("i7mYY");

var $hBcYV = parcelRequire("hBcYV");

var $8E2YL = parcelRequire("8E2YL");
function $322c68ffe6f8f794$var$EditorMethods(Props) {
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var match$1 = $hBcYV.useRouter(undefined);
    var goTo = match$1.goTo;
    var route = match$1.route;
    $baORH.IFrame.useCommandReceiver(undefined, /* RefreshConfig */ 2, function(param) {
        return Promise.all($i7mYY.map($i7mYY.keep(Array.from($2gEz2.Cache.cache.keys()), function(key) {
            return key.includes("/api/get_config");
        }), $2gEz2.revalidate));
    }, []);
    $baORH.IFrame.useCommandReceiver(undefined, /* Open */ 3, function(param) {
        if (typeof route === "number") return $iv6Yc._3(goTo, undefined, undefined, {
            TAG: /* Home */ 0,
            _0: {
                homeType: /* Index */ 0,
                filters: undefined,
                sort: undefined
            }
        });
    }, [
        config.id
    ]);
    $g85JO.useEffect(function() {
        $baORH.IFrame.sendCommand0(undefined, /* Ready */ 0);
        return function(param) {
            $baORH.IFrame.sendCommand0(undefined, /* Destroyed */ 1);
        };
    }, [
        config.id
    ]);
    return null;
}
$322c68ffe6f8f794$var$EditorMethods.displayName = "EditorMethods";
var $322c68ffe6f8f794$export$dd44f18ab656f3bb = $322c68ffe6f8f794$var$EditorMethods;
 /* SWR Not a pure module */ 
});

parcelRegister("bbixw", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $823f1a66b75c81dd$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $2gEz2 = parcelRequire("2gEz2");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $7bjme = parcelRequire("7bjme");

var $11Dnx = parcelRequire("11Dnx");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $7wIsS = parcelRequire("7wIsS");

var $hBcYV = parcelRequire("hBcYV");

var $4QdUt = parcelRequire("4QdUt");
var $823f1a66b75c81dd$export$e575061ef2a070eb = {
    contents: {}
};
function $823f1a66b75c81dd$var$ErrorReporter(Props) {
    var error = Props.error;
    var displayMessage = Props.displayMessage;
    var extraInfo = Props.extraInfo;
    var retry = Props.retry;
    var redirect = Props.redirect;
    var canRenderOnLiveOpt = Props.canRenderOnLive;
    var absoluteOpt = Props.absolute;
    var reportEvery = Props.reportEvery;
    var canRenderOnLive = canRenderOnLiveOpt !== undefined ? canRenderOnLiveOpt : false;
    var absolute = absoluteOpt !== undefined ? absoluteOpt : false;
    var match = $hBcYV.useRouter(undefined);
    var previewMode = match.previewMode;
    var isPreviewMode = $7bjme.notequal(previewMode, /* PreviewLive */ 1) && previewMode !== undefined;
    var displayMessage$1;
    var exit = 0;
    if (displayMessage !== undefined && (error.RE_EXN_ID === $4QdUt.LogicalError || error.RE_EXN_ID === $4QdUt.LogicalErrorUnreported)) displayMessage$1 = displayMessage;
    else exit = 1;
    if (exit === 1) displayMessage$1 = error.RE_EXN_ID === $2gEz2.NetworkError ? "There appears to be a problem with your internet connection" : displayMessage !== undefined || !(error.RE_EXN_ID === $4QdUt.LogicalError || error.RE_EXN_ID === $4QdUt.LogicalErrorUnreported) ? "An unexpected error has occurred." : error._1;
    var getCount = function getCount(param) {
        return $2whNH.getWithDefault($d3YYW.get($823f1a66b75c81dd$export$e575061ef2a070eb.contents, displayMessage$1), 0);
    };
    var incrementCounter = function incrementCounter(param) {
        if (reportEvery !== undefined) {
            $823f1a66b75c81dd$export$e575061ef2a070eb.contents[displayMessage$1] = getCount(undefined) >= reportEvery ? 0 : getCount(undefined) + 1 | 0;
            return;
        }
    };
    $g85JO.useEffect(function() {
        var currentCount = getCount(undefined);
        incrementCounter(undefined);
        console.error(error);
        if (isPreviewMode) return;
        if (error.RE_EXN_ID === $2gEz2.NetworkError || error.RE_EXN_ID === $4QdUt.LogicalErrorUnreported || !(error.RE_EXN_ID === $4QdUt.LogicalError && currentCount === 0)) Promise.resolve(undefined);
        else $4QdUt.error3(error, error._1, extraInfo);
        var timeout = redirect !== undefined ? $loT9g.some(setTimeout(function(param) {
            $iv6Yc._1(redirect, undefined);
        }, 0)) : undefined;
        return function(param) {
            $2whNH.forEach(timeout, function(id) {
                clearTimeout(id);
            });
        };
    }, []);
    var match$1 = $g85JO.useState(function() {
        return false;
    });
    var setRetrying = match$1[1];
    var retrying = match$1[0];
    var onClickRetry = $2whNH.map(retry, function(retry, param) {
        $iv6Yc._1(setRetrying, function(param) {
            return true;
        });
        var __x = $iv6Yc._1(retry, undefined);
        var __x$1 = $11Dnx.then_(function(param) {
            $iv6Yc._1(setRetrying, function(param) {
                return false;
            });
            return Promise.resolve(undefined);
        }, __x);
        $11Dnx.$$catch(function(param) {
            $iv6Yc._1(setRetrying, function(param) {
                return false;
            });
            return Promise.resolve(undefined);
        }, __x$1);
    });
    var renderRetry = function renderRetry(param) {
        return $2whNH.mapWithDefault(onClickRetry, null, function(onClickRetry) {
            return /*#__PURE__*/ $g85JO.createElement("button", {
                className: $ezf3v.prefix($1TRFX.make([
                    "text-gray-800 px-2 py-1 border border-solid border-gray-200",
                    retrying ? "bg-gray-300" : "bg-white"
                ])),
                disabled: retrying,
                onClick: function onClick(param) {
                    $iv6Yc._1(onClickRetry, undefined);
                }
            }, "Retry");
        });
    };
    var renderExit = function renderExit(param) {
        if (redirect !== undefined) return /*#__PURE__*/ $g85JO.createElement("button", {
            className: $ezf3v.prefix($1TRFX.make([
                "text-gray-800 px-2 py-1 border border-solid border-gray-200 bg-white"
            ])),
            onClick: function onClick(param) {
                $iv6Yc._1(redirect, undefined);
            }
        }, "Back");
        else return null;
    };
    if (isPreviewMode || canRenderOnLive) return /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            absolute ? "absolute inset-0" : "relative",
            "flex flex-col items-center justify-center bg-gray-50 text-gray-800 space-y-6"
        ]))
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("flex items-center justify-center h-12 w-12 rounded-full bg-white-200 text-gray-500")
    }, /*#__PURE__*/ $g85JO.createElement($7wIsS.UilExclamationTriangle.make, {})), /*#__PURE__*/ $g85JO.createElement("div", undefined, displayMessage$1), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("space-x-4")
    }, renderRetry(undefined), renderExit(undefined)), canRenderOnLive ? null : /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("mt-8 text-sm justify-center text-center")
    }, /*#__PURE__*/ $g85JO.createElement("div", undefined, "Customers will never see this page."), /*#__PURE__*/ $g85JO.createElement("div", undefined, "It is only visible in preview.")));
    else return null;
}
$823f1a66b75c81dd$var$ErrorReporter.displayName = "ErrorReporter";
var $823f1a66b75c81dd$export$dd44f18ab656f3bb = $823f1a66b75c81dd$var$ErrorReporter;
 /* SWR Not a pure module */ 
});
parcelRegister("11Dnx", function(module, exports) {

$parcel$export(module.exports, "then_", function () { return $0bf46e3d3223d8dd$export$b96ad11c1bfbed03; });
$parcel$export(module.exports, "$$catch", function () { return $0bf46e3d3223d8dd$export$e62bb7a22f80ae34; });

var $iv6Yc = parcelRequire("iv6Yc");
function $0bf46e3d3223d8dd$export$b96ad11c1bfbed03(arg1, obj) {
    return obj.then($iv6Yc.__1(arg1));
}
function $0bf46e3d3223d8dd$export$e62bb7a22f80ae34(arg1, obj) {
    return obj.catch($iv6Yc.__1(arg1));
}
 /* No side effect */ 
});


parcelRegister("1apRQ", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $0d9aca5b4e97b4c2$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $hR2pB = parcelRequire("hR2pB");
var $0d9aca5b4e97b4c2$export$602eac185826482c = {};
function $0d9aca5b4e97b4c2$var$PortalEmptying(Props) {
    var node = Props.node;
    var children = Props.children;
    var hasMounted = node.hasAttribute("data-portal-emptied");
    if (!hasMounted) {
        node.setAttribute("data-portal-emptied", "true");
        node.innerHTML = "";
    }
    return /*#__PURE__*/ $g85JO.createElement($hR2pB.default, {
        node: node,
        children: children
    });
}
$0d9aca5b4e97b4c2$var$PortalEmptying.displayName = "PortalEmptying";
var $0d9aca5b4e97b4c2$export$dd44f18ab656f3bb = $0d9aca5b4e97b4c2$var$PortalEmptying;
 /* react Not a pure module */ 
});

parcelRegister("cdK26", function(module, exports) {

$parcel$export(module.exports, "initialDocumentCookie", function () { return $8e5a681fe8edbb44$export$6d8a53c95d62f16a; });
$parcel$export(module.exports, "waitForShopifyAnalytics", function () { return $8e5a681fe8edbb44$export$f84603f07eeb1d63; });
$parcel$export(module.exports, "getProductPageProductId", function () { return $8e5a681fe8edbb44$export$655ef3e62ebfeb40; });
$parcel$export(module.exports, "getCollectionPageCollectionId", function () { return $8e5a681fe8edbb44$export$1ccfc961cba0f1c6; });
$parcel$export(module.exports, "getProductPageVariantId", function () { return $8e5a681fe8edbb44$export$cc267c015bc8901b; });
$parcel$export(module.exports, "isProductPage", function () { return $8e5a681fe8edbb44$export$a6ee0f0139d9689a; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $bygWp = parcelRequire("bygWp");
function $8e5a681fe8edbb44$var$fromMeta(meta) {
    var page = meta.page;
    var page$1 = page == null ? undefined : $loT9g.some(page);
    var product = meta.product;
    var resourceId = $2whNH.flatMap($2whNH.map(page$1, function(prim) {
        return prim.resourceId;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    });
    var resourceType = $2whNH.flatMap($2whNH.map(page$1, function(prim) {
        return prim.resourceType;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    });
    if (resourceType === undefined) return;
    switch(resourceType){
        case "collection":
            if (resourceId !== undefined) return {
                TAG: /* CollectionPage */ 0,
                collectionId: resourceId.toString()
            };
            else return;
        case "product":
            if (resourceId !== undefined) return {
                TAG: /* ProductPage */ 1,
                productId: resourceId.toString(),
                variants: $2whNH.getWithDefault($2whNH.flatMap($2whNH.map(product == null ? undefined : $loT9g.some(product), function(prim) {
                    return prim.variants;
                }), function(prim) {
                    if (prim == null) return;
                    else return $loT9g.some(prim);
                }), [])
            };
            else return;
        default:
            return;
    }
}
var $8e5a681fe8edbb44$export$6955bcca4cd3539f = {
    fromMeta: $8e5a681fe8edbb44$var$fromMeta
};
function $8e5a681fe8edbb44$export$6d8a53c95d62f16a(param) {
    return $2whNH.flatMap($2whNH.map($2whNH.flatMap($2whNH.map($2whNH.flatMap($2whNH.map(window.ShopifyAnalytics == null ? undefined : $loT9g.some(window.ShopifyAnalytics), function(prim) {
        return prim.lib;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), function(prim) {
        return prim.config;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), function(prim) {
        return prim.initialDocumentCookie;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    });
}
function $8e5a681fe8edbb44$export$f84603f07eeb1d63(retryCountOpt, param) {
    var retryCount = retryCountOpt !== undefined ? retryCountOpt : 0;
    var match = window.ShopifyAnalytics;
    var match$1 = retryCount > 25;
    if (!(match == null) || match$1) return Promise.resolve(undefined);
    else return new Promise(function(resolve, reject) {
        setTimeout(function(param) {
            $8e5a681fe8edbb44$export$f84603f07eeb1d63(retryCount + 1 | 0, undefined).then(function(result) {
                resolve(result);
            });
        }, 42);
    });
}
function $8e5a681fe8edbb44$export$c2a6433281518c91(param) {
    return $2whNH.flatMap($2whNH.flatMap($2whNH.map(window.ShopifyAnalytics == null ? undefined : $loT9g.some(window.ShopifyAnalytics), function(prim) {
        return prim.meta;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), $8e5a681fe8edbb44$var$fromMeta);
}
function $8e5a681fe8edbb44$export$655ef3e62ebfeb40(param) {
    return $2whNH.flatMap($8e5a681fe8edbb44$export$c2a6433281518c91(undefined), function(page) {
        if (page.TAG === /* CollectionPage */ 0) return;
        else return page.productId;
    });
}
function $8e5a681fe8edbb44$export$1ccfc961cba0f1c6(param) {
    return $2whNH.flatMap($8e5a681fe8edbb44$export$c2a6433281518c91(undefined), function(page) {
        if (page.TAG === /* CollectionPage */ 0) return page.collectionId;
    });
}
function $8e5a681fe8edbb44$export$cc267c015bc8901b(param) {
    var variants = $2whNH.mapWithDefault($8e5a681fe8edbb44$export$c2a6433281518c91(undefined), [], function(page) {
        if (page.TAG === /* CollectionPage */ 0) return [];
        else return page.variants;
    });
    var idToFind = $bygWp.getParam(window.location.href, "variant");
    var foundVariant = idToFind !== undefined ? $i7mYY.getBy(variants, function(v) {
        var currentId = $2whNH.map($loT9g.nullable_to_opt(v.id), function(prim) {
            return prim.toString();
        });
        return $7bjme.equal(currentId, idToFind);
    }) : undefined;
    var firstVariant = $i7mYY.get(variants, 0);
    return $2whNH.map($2whNH.flatMap($2whNH.map($2whNH.orElse(foundVariant, firstVariant), function(prim) {
        return prim.id;
    }), function(prim) {
        if (prim == null) return;
        else return $loT9g.some(prim);
    }), function(prim) {
        return prim.toString();
    });
}
function $8e5a681fe8edbb44$export$a6ee0f0139d9689a(param) {
    return $2whNH.isSome($8e5a681fe8edbb44$export$655ef3e62ebfeb40(undefined));
}
 /* No side effect */ 
});

parcelRegister("lKNu0", function(module, exports) {

$parcel$export(module.exports, "useSettings", function () { return $fd644728ba503d34$export$9115b42802a3e44f; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2whNH = parcelRequire("2whNH");

var $j6SPN = parcelRequire("j6SPN");

var $8E2YL = parcelRequire("8E2YL");

var $e4Coc = parcelRequire("e4Coc");
function $fd644728ba503d34$export$9115b42802a3e44f(attributes) {
    var match = $8E2YL.use(undefined);
    var fromConfig = $2whNH.flatMap(match.config.transitiveAccount, function(account) {
        return account.navMenuConfig;
    });
    var fromConfig$1 = $2whNH.map(fromConfig, function(config) {
        return $j6SPN.mergeAttributes(config, attributes);
    });
    return $e4Coc.getSettings(fromConfig$1, undefined);
}
 /* NavMenuConfig-Showside Not a pure module */ 
});

parcelRegister("6e14p", function(module, exports) {

$parcel$export(module.exports, "useIsStyleLoaded", function () { return $4884e15e200d2e55$export$adadf97df3f958bb; });
$parcel$export(module.exports, "makeProps", function () { return $4884e15e200d2e55$export$d4ee11730f14c667; });
$parcel$export(module.exports, "make", function () { return $4884e15e200d2e55$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $hrFTE = parcelRequire("hrFTE");
function $4884e15e200d2e55$export$3c892654f38bd67d(param) {
    var match = $g85JO.useState(function() {
        return false;
    });
    var setStyleLoaded = match[1];
    $g85JO.useEffect(function() {
        $hrFTE.insertCSS(function(param) {
            $iv6Yc._1(setStyleLoaded, function(param) {
                return true;
            });
        }, undefined);
    }, []);
    return match[0];
}
var $4884e15e200d2e55$export$a078c61943f9dbbe = /*#__PURE__*/ $g85JO.createContext(false);
var $4884e15e200d2e55$var$provider = $4884e15e200d2e55$export$a078c61943f9dbbe.Provider;
function $4884e15e200d2e55$var$CriticalCSSProvider$Provider(Props) {
    var children = Props.children;
    var isStyleLoaded = $4884e15e200d2e55$export$3c892654f38bd67d(undefined);
    return /*#__PURE__*/ $g85JO.createElement($4884e15e200d2e55$var$provider, {
        value: isStyleLoaded,
        children: children
    });
}
$4884e15e200d2e55$var$CriticalCSSProvider$Provider.displayName = "CriticalCSSProvider.Provider";
var $4884e15e200d2e55$export$2881499e37b75b9a = {
    provider: $4884e15e200d2e55$var$provider,
    make: $4884e15e200d2e55$var$CriticalCSSProvider$Provider
};
function $4884e15e200d2e55$export$adadf97df3f958bb(param) {
    return $g85JO.useContext($4884e15e200d2e55$export$a078c61943f9dbbe);
}
function $4884e15e200d2e55$export$d4ee11730f14c667(prim0, prim1, prim2) {
    var tmp = {
        children: prim0
    };
    if (prim1 !== undefined) tmp.key = prim1;
    return tmp;
}
var $4884e15e200d2e55$export$dd44f18ab656f3bb = $4884e15e200d2e55$var$CriticalCSSProvider$Provider;
 /* context Not a pure module */ 
});

parcelRegister("8yLAG", function(module, exports) {

$parcel$export(module.exports, "useDocumentReadyStateChange", function () { return $63b66a3db7611780$export$9f23f363ee1174e1; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7GW0c = parcelRequire("7GW0c");
function $63b66a3db7611780$export$9f23f363ee1174e1(param) {
    var match = $g85JO.useState(function() {
        return $7GW0c.$$Document.readyState(document);
    });
    var setReadyState = match[1];
    $g85JO.useEffect(function() {
        var handleReadyStateChange = function handleReadyStateChange(param) {
            $iv6Yc._1(setReadyState, function(param) {
                return $7GW0c.$$Document.readyState(document);
            });
        };
        document.addEventListener("readystatechange", handleReadyStateChange);
        return function(param) {
            document.removeEventListener("readystatechange", handleReadyStateChange);
        };
    }, []);
    return match[0];
}
 /* react Not a pure module */ 
});


parcelRegister("hQWQG", function(module, exports) {

$parcel$export(module.exports, "ContentId", function () { return $cff4f11bdb1bf2d0$export$bb6896aa5755c251; });
$parcel$export(module.exports, "SectionId", function () { return $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $ki9MN = parcelRequire("ki9MN");
var $cff4f11bdb1bf2d0$export$bb6896aa5755c251 = $ki9MN.Make({});
var $cff4f11bdb1bf2d0$export$9bbe9bfd3294dd44 = $ki9MN.Make({});
 /* ContentId Not a pure module */ 
});

parcelRegister("2Mb3w", function(module, exports) {

$parcel$export(module.exports, "getBrowser", function () { return $2058a3ec51237c4b$export$89e15fc796a4a429; });
$parcel$export(module.exports, "isSafariVersion__16_3", function () { return $2058a3ec51237c4b$export$91773661b17fb447; });
$parcel$export(module.exports, "getOS", function () { return $2058a3ec51237c4b$export$34ee789f81ad4cb9; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");
var $2058a3ec51237c4b$export$60cc2146340a7149 = function getAppVersion() {
    return navigator.appVersion;
};
var $2058a3ec51237c4b$export$7935961ef7719cb0 = function getUserAgent() {
    return navigator.userAgent;
};
function $2058a3ec51237c4b$export$89e15fc796a4a429(param) {
    var userAgentString = $iv6Yc._1($2058a3ec51237c4b$export$7935961ef7719cb0, undefined);
    var chromeAgent = userAgentString.indexOf("Chrome") > -1;
    var firefoxAgent = userAgentString.indexOf("Firefox") > -1;
    var safariAgent = userAgentString.indexOf("Safari") > -1;
    if (chromeAgent) return /* Chrome */ 0;
    else if (firefoxAgent) return /* Firefox */ 2;
    else if (safariAgent) return /* Safari */ 1;
    else return /* UnknownBrowser */ 3;
}
function $2058a3ec51237c4b$export$91773661b17fb447(param) {
    var userAgentString = $iv6Yc._1($2058a3ec51237c4b$export$7935961ef7719cb0, undefined);
    var match = $2058a3ec51237c4b$export$89e15fc796a4a429(undefined);
    if (match !== 1) return false;
    else return userAgentString.includes("iPhone OS 16_3");
}
function $2058a3ec51237c4b$export$34ee789f81ad4cb9(param) {
    var appVersion = $iv6Yc._1($2058a3ec51237c4b$export$60cc2146340a7149, undefined);
    if (appVersion.includes("Win")) return /* Windows */ 1;
    else if (appVersion.includes("iPhone OS")) return /* IOS */ 3;
    else if (appVersion.includes("Mac")) return /* Mac */ 0;
    else if (appVersion.includes("Linux")) return /* Linux */ 2;
    else return /* UnknownOs */ 4;
}
 /* No side effect */ 
});

parcelRegister("2XXXw", function(module, exports) {

$parcel$export(module.exports, "ScrollRestorationLocalStorage", function () { return $228f9a1798c51d97$export$791f6fca0d60efd9; });
$parcel$export(module.exports, "setBreakingPoint", function () { return $228f9a1798c51d97$export$1dfa5e58b4233c3; });
$parcel$export(module.exports, "removeBreakingPoint", function () { return $228f9a1798c51d97$export$16e7fafba7e176d; });
$parcel$export(module.exports, "setCurrentScroll", function () { return $228f9a1798c51d97$export$6e32c7a2bca8fb40; });
$parcel$export(module.exports, "getClosestBreakingPoint", function () { return $228f9a1798c51d97$export$69a851a551f434f5; });
$parcel$export(module.exports, "setScrollLock", function () { return $228f9a1798c51d97$export$a2324b57a6a5ec84; });
$parcel$export(module.exports, "clearScrollLock", function () { return $228f9a1798c51d97$export$14e0addec6650b88; });
$parcel$export(module.exports, "getScroll", function () { return $228f9a1798c51d97$export$ff41c598de81c14a; });
$parcel$export(module.exports, "isBlockingOnScrollEvent", function () { return $228f9a1798c51d97$export$51e57029e6716073; });
$parcel$export(module.exports, "useScrollRestoration", function () { return $228f9a1798c51d97$export$c4ffdfe23dd48040; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $79vie = parcelRequire("79vie");

var $58Tj9 = parcelRequire("58Tj9");

var $jVmMx = parcelRequire("jVmMx");

var $kJhYp = parcelRequire("kJhYp");

var $gO2mJ = parcelRequire("gO2mJ");

var $8wpG4 = parcelRequire("8wpG4");

var $efwy1 = parcelRequire("efwy1");

var $25dxq = parcelRequire("25dxq");
$gO2mJ.setScrollRestoration("manual");
function $228f9a1798c51d97$export$a91724a679733655(position) {
    if (typeof position === "number") return $iv6Yc._2($jVmMx.Encode.array, [
        "Zero"
    ], $jVmMx.Encode.string);
    else if (position.TAG === /* Pixels */ 0) return $jVmMx.Encode.deccoVariantWithPayload(position._0, "Pixels", $jVmMx.Encode.$$int);
    else return $jVmMx.Encode.deccoVariantWithPayload(position._0, "Index", $jVmMx.Encode.$$int);
}
var $228f9a1798c51d97$var$zero = $79vie.map($79vie.index(0, $jVmMx.Decode.exactString("Zero")), function(param) {
    return /* Zero */ 0;
});
var $228f9a1798c51d97$var$pixels = $jVmMx.Decode.deccoVariantWithPayload("Pixels", $79vie.$$int, function(v) {
    return {
        TAG: /* Pixels */ 0,
        _0: v
    };
});
var $228f9a1798c51d97$var$index = $jVmMx.Decode.deccoVariantWithPayload("Index", $79vie.$$int, function(v) {
    return {
        TAG: /* Index */ 1,
        _0: v
    };
});
var $228f9a1798c51d97$export$932a824d711ed6ad = $79vie.oneOf($228f9a1798c51d97$var$zero, [
    $228f9a1798c51d97$var$pixels,
    $228f9a1798c51d97$var$index
]);
function $228f9a1798c51d97$var$set(key, value) {
    $8wpG4.set(undefined, {
        NAME: "scrollRestoration",
        VAL: key
    }, JSON.stringify($228f9a1798c51d97$export$a91724a679733655(value)));
}
function $228f9a1798c51d97$var$$$delete(key) {
    $8wpG4.$$delete(undefined, {
        NAME: "scrollRestoration",
        VAL: key
    });
}
function $228f9a1798c51d97$var$get(key) {
    return $2whNH.mapWithDefault($8wpG4.get(undefined, {
        NAME: "scrollRestoration",
        VAL: key
    }), /* Zero */ 0, function(position) {
        var result = $79vie.decodeValue(JSON.parse(position), $228f9a1798c51d97$export$932a824d711ed6ad);
        if (result.TAG === /* Ok */ 0) return result._0;
        else return /* Zero */ 0;
    });
}
var $228f9a1798c51d97$export$791f6fca0d60efd9 = {
    set: $228f9a1798c51d97$var$set,
    $$delete: $228f9a1798c51d97$var$$$delete,
    get: $228f9a1798c51d97$var$get
};
var $228f9a1798c51d97$export$f3a17d4d921911b3 = {};
var $228f9a1798c51d97$export$d4351b0ee1c8c8c6 = {
    contents: undefined
};
var $228f9a1798c51d97$export$1f6d3e4fc8cedc8e = {
    contents: {}
};
function $228f9a1798c51d97$export$6bbf62f168c1dddc($$location, id, position) {
    var bucketKey = $kJhYp.toQueryString(undefined, $kJhYp.sanitizeLocation($$location));
    var bucket = $d3YYW.get($228f9a1798c51d97$export$f3a17d4d921911b3, bucketKey);
    $228f9a1798c51d97$var$set(id, position);
    if (bucket !== undefined) $loT9g.valFromOption(bucket)[id] = position;
    else $228f9a1798c51d97$export$f3a17d4d921911b3[bucketKey] = $d3YYW.fromArray([
        [
            id,
            position
        ]
    ]);
}
function $228f9a1798c51d97$export$1dfa5e58b4233c3(paddingOpt, id, center) {
    var padding = paddingOpt !== undefined ? paddingOpt : 0;
    $228f9a1798c51d97$export$1f6d3e4fc8cedc8e.contents[id] = {
        center: center,
        padding: padding
    };
}
function $228f9a1798c51d97$export$16e7fafba7e176d(idToDelete) {
    $228f9a1798c51d97$export$1f6d3e4fc8cedc8e.contents = $d3YYW.fromArray($i7mYY.keepMap($d3YYW.entries($228f9a1798c51d97$export$1f6d3e4fc8cedc8e.contents), function(param) {
        var id = param[0];
        if (id !== idToDelete) return [
            id,
            param[1]
        ];
    }));
}
function $228f9a1798c51d97$export$684cfbe7f928b61e(param) {
    return $58Tj9.stableSortBy($d3YYW.values($228f9a1798c51d97$export$1f6d3e4fc8cedc8e.contents), function(a, b) {
        if (a.center > b.center) return 1;
        else if (a.center < b.center) return -1;
        else return 0;
    });
}
function $228f9a1798c51d97$export$6e32c7a2bca8fb40(namespace, id, target) {
    $228f9a1798c51d97$export$6bbf62f168c1dddc($kJhYp.getStatesByNamespace(namespace).current, id, target);
}
function $228f9a1798c51d97$export$69a851a551f434f5(currentScroll, targetScroll) {
    var allPoints = $228f9a1798c51d97$export$684cfbe7f928b61e(undefined);
    return $i7mYY.reduce(allPoints, targetScroll, function(prev, curr) {
        if ((curr.center - curr.padding | 0) <= currentScroll && (curr.center + curr.padding | 0) >= currentScroll) return currentScroll;
        else if (curr.center <= currentScroll) return curr.center;
        else return prev;
    });
}
function $228f9a1798c51d97$export$a2324b57a6a5ec84(dref) {
    $2whNH.map($loT9g.nullable_to_opt(dref.current), function(el) {
        $228f9a1798c51d97$export$d4351b0ee1c8c8c6.contents = {
            element: el,
            boundingClientRect: el.getBoundingClientRect()
        };
    });
}
function $228f9a1798c51d97$export$14e0addec6650b88(param) {
    $228f9a1798c51d97$export$d4351b0ee1c8c8c6.contents = undefined;
}
function $228f9a1798c51d97$export$ff41c598de81c14a(namespace, localStorage, id) {
    var bucketKey = $kJhYp.toQueryString(undefined, $kJhYp.sanitizeLocation($kJhYp.getStatesByNamespace(namespace).current));
    var fromBucket = $2whNH.flatMap($d3YYW.get($228f9a1798c51d97$export$f3a17d4d921911b3, bucketKey), function(bucket) {
        return $d3YYW.get(bucket, id);
    });
    if (fromBucket !== undefined) return fromBucket;
    if (!localStorage) return /* Zero */ 0;
    var fromLocalStorage = $228f9a1798c51d97$var$get(id);
    $228f9a1798c51d97$var$$$delete(id);
    return fromLocalStorage;
}
var $228f9a1798c51d97$export$398994a7cd250b7e = {
    contents: false
};
function $228f9a1798c51d97$export$aded8d3ce7fe43e1(bool) {
    $228f9a1798c51d97$export$398994a7cd250b7e.contents = bool;
}
function $228f9a1798c51d97$export$51e57029e6716073(param) {
    return $228f9a1798c51d97$export$398994a7cd250b7e.contents;
}
function $228f9a1798c51d97$export$c4ffdfe23dd48040(id) {
    var timeoutRef = $g85JO.useRef(undefined);
    var match = $efwy1.use(undefined);
    var namespace = match.namespace;
    var getInitialResult = function getInitialResult(localStorage) {
        return {
            position: $2whNH.getWithDefault($2whNH.map(id, function(param) {
                return $228f9a1798c51d97$export$ff41c598de81c14a(namespace, localStorage, param);
            }), /* Zero */ 0),
            lock: undefined
        };
    };
    var getCurrentKey = function getCurrentKey(param) {
        return $kJhYp.toQueryString(undefined, $kJhYp.sanitizeLocation($kJhYp.getStatesByNamespace(namespace).current));
    };
    var key = $g85JO.useRef(getCurrentKey(undefined));
    $g85JO.useEffect(function() {
        return function(param) {
            $2whNH.forEach(timeoutRef.current, function(prim) {
                clearTimeout(prim);
            });
        };
    }, []);
    var match$1 = $g85JO.useState(function() {
        return getInitialResult(false);
    });
    var setResult = match$1[1];
    var setResult$1 = function setResult$1(fn) {
        $228f9a1798c51d97$export$398994a7cd250b7e.contents = true;
        $iv6Yc._1(setResult, fn);
        timeoutRef.current = $loT9g.some(setTimeout(function(param) {
            $228f9a1798c51d97$export$398994a7cd250b7e.contents = false;
        }, 100));
    };
    $25dxq.useBrowserNavigation(function(navigationType) {
        if (navigationType !== 1) return $2whNH.forEach(id, $228f9a1798c51d97$var$$$delete);
        var nextResult = getInitialResult(true);
        var match = nextResult.position;
        var nextResultValue = typeof match === "number" ? 0 : match._0;
        setResult$1(function(previousResult) {
            var match = previousResult.position;
            if (typeof match === "number" || match._0 < nextResultValue) return nextResult;
            else return previousResult;
        });
    }, []);
    $g85JO.useEffect(function() {
        setResult$1(function(param) {
            return getInitialResult(false);
        });
    }, [
        id
    ]);
    var update = function update(param) {
        if (id === undefined) return;
        var nextKey = getCurrentKey(undefined);
        if (key.current !== nextKey) {
            setResult$1(function(param) {
                return {
                    position: $228f9a1798c51d97$export$ff41c598de81c14a(namespace, false, id),
                    lock: $228f9a1798c51d97$export$d4351b0ee1c8c8c6.contents
                };
            });
            key.current = nextKey;
            return;
        }
    };
    $g85JO.useEffect(function() {
        $kJhYp.setLocalCallbacksByNamespace(namespace, $i7mYY.concat($kJhYp.getStatesByNamespace(namespace).localCallbacks, [
            update
        ]));
        return function(param) {
            $kJhYp.setLocalCallbacksByNamespace(namespace, $i7mYY.keep($kJhYp.getStatesByNamespace(namespace).localCallbacks, function(fn) {
                return fn !== update;
            }));
        };
    }, []);
    return match$1[0];
}
 /*  Not a pure module */ 
});
parcelRegister("25dxq", function(module, exports) {

$parcel$export(module.exports, "useBrowserNavigation", function () { return $18468cc594e5b21b$export$e8c1c060dda75c72; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $2Mb3w = parcelRequire("2Mb3w");

var $052u6 = parcelRequire("052u6");
function $18468cc594e5b21b$var$useSafariHack(enabledOpt, callback, dependencies) {
    var enabled = enabledOpt !== undefined ? enabledOpt : false;
    $052u6.LegacyNavigationTiming.useLegacyNavigationTiming(enabled, function(param) {
        $iv6Yc._1(callback, param._type);
    }, dependencies);
}
var $18468cc594e5b21b$export$e02aa0e39cbdc151 = {
    useSafariHack: $18468cc594e5b21b$var$useSafariHack
};
function $18468cc594e5b21b$export$e8c1c060dda75c72(callback, dependencies) {
    var isSafari = $2Mb3w.getBrowser(undefined) === /* Safari */ 1;
    $18468cc594e5b21b$var$useSafariHack(isSafari, callback, dependencies);
    $052u6.usePerformanceObserver1(!isSafari, true, /* Navigation */ 0, function(param) {
        $iv6Yc._1(callback, param._type);
    }, dependencies);
}
 /* PerformanceObserver-Showside Not a pure module */ 
});
parcelRegister("052u6", function(module, exports) {

$parcel$export(module.exports, "LegacyNavigationTiming", function () { return $00f26519795813cb$export$127e32ccb8a6e066; });
$parcel$export(module.exports, "usePerformanceObserver1", function () { return $00f26519795813cb$export$d2dfc13adeb0ed2d; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");
function $00f26519795813cb$export$48c17662a6902497(param) {
    return $2whNH.isSome(window.PerformanceObserver);
}
function $00f26519795813cb$export$e815e306a6ff66ed(entryType) {
    return "navigation";
}
function $00f26519795813cb$export$2fe53163c7bc4eaf(ext_type) {
    if (ext_type === "back_forward") return /* BackForward */ 1;
    else if (ext_type === "navigate") return /* Navigate */ 0;
    else return /* Reload */ 2;
}
function $00f26519795813cb$export$8ceb1d4b31259502(ext_entry) {
    return {
        _type: $00f26519795813cb$export$2fe53163c7bc4eaf(ext_entry.type)
    };
}
function $00f26519795813cb$export$d3d061a08d0fe848(enabled, options, callback, dependencies) {
    var supported = $2whNH.isSome(window.PerformanceObserver);
    $g85JO.useEffect(function() {
        if (!(enabled && supported)) return;
        var observer = new PerformanceObserver(function(entries) {
            $iv6Yc._1(callback, $i7mYY.map(entries.getEntries(), $00f26519795813cb$export$8ceb1d4b31259502));
        });
        try {
            observer.observe(options);
            var observer$1 = observer;
            return function(param) {
                $2whNH.forEach(observer$1, function(obs) {
                    obs.disconnect();
                });
            };
        } catch (e) {
            return;
        }
    }, dependencies);
}
function $00f26519795813cb$var$useLegacyNavigationTiming(enabledOpt, callback, dependencies) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var callback$1 = function callback$1(e) {
        $2whNH.forEach($2whNH.map($i7mYY.get(window.performance.getEntriesByType("navigation"), 0), function(entry) {
            return {
                _type: $2whNH.getWithDefault(e.persisted, false) ? /* BackForward */ 1 : ({
                    _type: $00f26519795813cb$export$2fe53163c7bc4eaf(entry.type)
                })._type
            };
        }), callback);
    };
    $g85JO.useEffect(function() {
        if (enabled) {
            window.addEventListener("pageshow", callback$1);
            return function(param) {
                window.removeEventListener("pageshow", callback$1);
            };
        }
    }, dependencies);
}
var $00f26519795813cb$export$127e32ccb8a6e066 = {
    useLegacyNavigationTiming: $00f26519795813cb$var$useLegacyNavigationTiming
};
function $00f26519795813cb$export$d2dfc13adeb0ed2d(enabledOpt, bufferedOpt, entryType, callback, dependencies) {
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var buffered = bufferedOpt !== undefined ? bufferedOpt : false;
    var options_type = "navigation";
    var options = {
        entryTypes: undefined,
        type: options_type,
        buffered: buffered
    };
    $00f26519795813cb$export$d3d061a08d0fe848(enabled, options, function(entries) {
        $2whNH.forEach($i7mYY.get(entries, 0), callback);
    }, dependencies);
}
 /* react Not a pure module */ 
});



})();
//# sourceMappingURL=NavMenuEntrypoint.bs.5686b8d4.js.map
